function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { forwardRef, useState, useRef, useEffect, useCallback, useContext, useMemo } from 'react';
import PhoneInputComponent, { getCountryCallingCode } from 'react-phone-number-input';
export { isValidPhoneNumber } from 'react-phone-number-input';
import BaseModal from 'react-modal';
import { RemoveScroll } from 'react-remove-scroll';
import { SwiperSlide, Swiper } from 'swiper/react';
import sanityImageUrl from '@sanity/image-url';
import sanityClient from '@sanity/client';

var Theme = function Theme(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

function toVal(mix) {
  var k,
      y,
      str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }

  return str;
}

function clsx() {
  var i = 0,
      tmp,
      x,
      str = '';

  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }

  return str;
}

var styles$w = {
  "button": "Button-module_button__1yqRw",
  "size-small": "Button-module_size-small__2nq-v",
  "sizeSmall": "Button-module_size-small__2nq-v",
  "center": "Button-module_center__1IKjy",
  "full": "Button-module_full__3N4Ch",
  "with-icon": "Button-module_with-icon__pwloV",
  "withIcon": "Button-module_with-icon__pwloV",
  "icon": "Button-module_icon__3aWV9",
  "only-icon": "Button-module_only-icon__qPgqZ",
  "onlyIcon": "Button-module_only-icon__qPgqZ",
  "type-primary": "Button-module_type-primary__1TMWF",
  "typePrimary": "Button-module_type-primary__1TMWF",
  "type-secondary": "Button-module_type-secondary__2TDfZ",
  "typeSecondary": "Button-module_type-secondary__2TDfZ",
  "type-secondary-gray": "Button-module_type-secondary-gray__dMNQy",
  "typeSecondaryGray": "Button-module_type-secondary-gray__dMNQy",
  "type-tertiary": "Button-module_type-tertiary__imUo6",
  "typeTertiary": "Button-module_type-tertiary__imUo6",
  "is-disabled": "Button-module_is-disabled__275ef",
  "isDisabled": "Button-module_is-disabled__275ef",
  "type-gray": "Button-module_type-gray__2UOom",
  "typeGray": "Button-module_type-gray__2UOom",
  "type-link": "Button-module_type-link__1uaVJ",
  "typeLink": "Button-module_type-link__1uaVJ",
  "no-wrap": "Button-module_no-wrap__3hFm4",
  "noWrap": "Button-module_no-wrap__3hFm4",
  "loading": "Button-module_loading__IDrla",
  "spinner": "Button-module_spinner__1usQO"
};
var accessibility = 61697;
var alarm = 61700;
var anchor = 61702;
var chat = 61708;
var check = 61709;
var circle = 61715;
var close = 61716;
var countries = 61717;
var days = 61718;
var dining = 61719;
var download = 61721;
var duration = 61726;
var expand = 61729;
var facebook = 61730;
var flag = 61731;
var flight = 61732;
var info = 61737;
var instagram = 61738;
var limited = 61740;
var pack = 61744;
var pdf = 61745;
var phone = 61746;
var pinterest = 61747;
var placeholder = 61748;
var play = 61749;
var plus = 61750;
var ports = 61751;
var privato = 61753;
var routes = 61758;
var search = 61759;
var services = 61760;
var ship = 61761;
var star = 61765;
var suites = 61766;
var twitter = 61767;
var voyages = 61769;
var icons = {
  accessibility: accessibility,
  "activity-level-empty": 61698,
  "activity-level-full": 61699,
  alarm: alarm,
  "all-inclusive-offer": 61701,
  anchor: anchor,
  "antarctica-bridge": 61703,
  "arrow-down": 61704,
  "arrow-left": 61705,
  "arrow-right": 61706,
  "arrow-up": 61707,
  chat: chat,
  check: check,
  "chevron-down": 61710,
  "chevron-left": 61711,
  "chevron-right": 61712,
  "chevron-up": 61713,
  "circle-check": 61714,
  circle: circle,
  close: close,
  countries: countries,
  days: days,
  dining: dining,
  "door-to-door": 61720,
  download: download,
  "duration_2-h": 61722,
  "duration-4-h": 61723,
  "duration-8-h": 61724,
  "duration-all-day": 61725,
  duration: duration,
  "early-booking-bonus": 61727,
  "evening-excursions": 61728,
  expand: expand,
  facebook: facebook,
  flag: flag,
  flight: flight,
  "food-beverage": 61733,
  "free-flight": 61734,
  "free-hotel": 61735,
  "free-transfers": 61736,
  info: info,
  instagram: instagram,
  "limited-space-available": 61739,
  limited: limited,
  "meal-included": 61741,
  "new": 61742,
  "pack-denali": 61743,
  pack: pack,
  pdf: pdf,
  phone: phone,
  pinterest: pinterest,
  placeholder: placeholder,
  play: play,
  plus: plus,
  ports: ports,
  "private-flight-in-business-class": 61752,
  privato: privato,
  "public-area": 61754,
  "quito-by-night": 61755,
  "reduced-fares-in-business-class": 61756,
  "routes-2": 61757,
  routes: routes,
  search: search,
  services: services,
  ship: ship,
  "shore-excursions": 61762,
  "single-fares": 61763,
  "special-price": 61764,
  star: star,
  suites: suites,
  twitter: twitter,
  "venetian-society-saving": 61768,
  voyages: voyages,
  "world-cruise-collection": 61770,
  "you-tube": 61771
};
var styles$v = {
  "icon-container": "Icon-module_icon-container__PnDsT",
  "iconContainer": "Icon-module_icon-container__PnDsT",
  "padding-inline": "Icon-module_padding-inline__j2luD",
  "paddingInline": "Icon-module_padding-inline__j2luD",
  "padding-small": "Icon-module_padding-small__1GBkQ",
  "paddingSmall": "Icon-module_padding-small__1GBkQ",
  "padding-medium": "Icon-module_padding-medium__OBuAx",
  "paddingMedium": "Icon-module_padding-medium__OBuAx",
  "padding-large": "Icon-module_padding-large__3CILr",
  "paddingLarge": "Icon-module_padding-large__3CILr",
  "size-0_5x": "Icon-module_size-0_5x__Mjx7e",
  "size05X": "Icon-module_size-0_5x__Mjx7e",
  "size-1x": "Icon-module_size-1x__XJxZH",
  "size1X": "Icon-module_size-1x__XJxZH",
  "size-1_5x": "Icon-module_size-1_5x__XCy17",
  "size15X": "Icon-module_size-1_5x__XCy17",
  "size-2x": "Icon-module_size-2x__3jyf0",
  "size2X": "Icon-module_size-2x__3jyf0",
  "size-2_5x": "Icon-module_size-2_5x__123VY",
  "size25X": "Icon-module_size-2_5x__123VY",
  "size-3x": "Icon-module_size-3x__1eawo",
  "size3X": "Icon-module_size-3x__1eawo",
  "size-4x": "Icon-module_size-4x__HnDyq",
  "size4X": "Icon-module_size-4x__HnDyq"
};

var Icon = function Icon(_ref2) {
  var _clsx;

  var name = _ref2.name,
      className = _ref2.className,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "1x" : _ref2$size,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? "medium" : _ref2$padding,
      ariaHidden = _ref2.ariaHidden;
  var icon = icons[name];
  if (!icon) return null;
  var iconFontCode = String.fromCodePoint(icon);
  return /*#__PURE__*/React.createElement("i", {
    className: clsx(className, (_clsx = {}, _clsx[styles$v.iconContainer] = true, _clsx[styles$v.paddingInline] = padding == "inline", _clsx[styles$v.paddingSmall] = padding == "small", _clsx[styles$v.paddingMedium] = padding == "medium", _clsx[styles$v.paddingLarge] = padding == "large", _clsx[styles$v.size05X] = size == "0.5x", _clsx[styles$v.size1X] = size == "1x", _clsx[styles$v.size15X] = size == "1.5x", _clsx[styles$v.size2X] = size == "2x", _clsx[styles$v.size25X] = size == "2.5x", _clsx[styles$v.size3X] = size == "3x", _clsx[styles$v.size4X] = size == "4x", _clsx)),
    "data-icon": iconFontCode,
    "aria-hidden": ariaHidden
  });
};

function generateClassNames(args) {
  var _clsx2;

  var className = args.className,
      centerText = args.centerText,
      _args$size = args.size,
      size = _args$size === void 0 ? "normal" : _args$size,
      _args$variant = args.variant,
      variant = _args$variant === void 0 ? "primary" : _args$variant,
      loading = args.loading,
      disabled = args.disabled,
      _args$full = args.full,
      full = _args$full === void 0 ? false : _args$full,
      iconName = args.iconName,
      hasChildren = args.hasChildren,
      noWrap = args.noWrap;
  var btnClass = clsx(styles$w.button, className, (_clsx2 = {}, _clsx2[styles$w.center] = centerText, _clsx2[styles$w.sizeSmall] = size == "small", _clsx2[styles$w.typePrimary] = variant == "primary", _clsx2[styles$w.typeSecondary] = variant == "secondary", _clsx2[styles$w.typeSecondaryGray] = variant == "secondary-gray", _clsx2[styles$w.typeTertiary] = variant == "tertiary", _clsx2[styles$w.typeLink] = variant == "link", _clsx2[styles$w.loading] = loading, _clsx2[styles$w.isDisabled] = disabled, _clsx2[styles$w.full] = full, _clsx2[styles$w.withIcon] = iconName, _clsx2[styles$w.onlyIcon] = iconName && !hasChildren, _clsx2[styles$w.noWrap] = noWrap, _clsx2));
  return btnClass;
}

var Button = function Button(props) {
  var renderAs = props.renderAs,
      loading = props.loading,
      noWrap = props.noWrap,
      variant = props.variant,
      size = props.size,
      full = props.full,
      disabled = props.disabled,
      centerText = props.centerText,
      className = props.className,
      iconName = props.iconName,
      children = props.children,
      dataContentPiece = props.dataContentPiece,
      dataContentParams = props.dataContentParams,
      otherProps = _objectWithoutPropertiesLoose(props, ["renderAs", "loading", "noWrap", "variant", "size", "full", "disabled", "centerText", "className", "iconName", "children", "dataContentPiece", "dataContentParams"]);

  var actualVariant = variant || "primary";
  var ButtonComponent;
  if ("href" in props && !!props.href || props.renderAs == "a" || props.renderAs == undefined) ButtonComponent = "a";else if (props.renderAs == "button") ButtonComponent = "button";else if (props.renderAs == "div") ButtonComponent = "div";
  var overrideDataContentPiece = dataContentPiece || props["data-content-piece"];
  var overrideDataContentParams = dataContentParams || props["data-content-params"];
  var buttonClassNames = generateClassNames({
    className: className,
    centerText: centerText,
    size: size,
    variant: variant,
    loading: loading,
    disabled: disabled,
    full: full,
    iconName: iconName,
    noWrap: noWrap,
    hasChildren: React.Children.count(children) > 0
  });
  return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({
    variant: actualVariant
  }, otherProps, {
    className: buttonClassNames,
    "data-content-piece": overrideDataContentPiece,
    "data-content-params": overrideDataContentParams ? JSON.stringify(overrideDataContentParams) : undefined
  }), children && !loading && /*#__PURE__*/React.createElement("span", null, children), iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: "1.5x",
    className: styles$w.icon,
    padding: false
  }));
};

var styles$u = {
  "button": "PaginationButton-module_button__3RLwG"
};

var PaginationButton = function PaginationButton(_ref3) {
  var arrow = _ref3.arrow,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? "" : _ref3$className,
      buttonProps = _objectWithoutPropertiesLoose(_ref3, ["arrow", "className"]);

  var icon = arrow == "left" ? "chevron-left" : "chevron-right";
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    className: clsx(className, styles$u.button),
    variant: "secondary",
    iconName: icon
  }, buttonProps));
};

var styles$t = {
  "buttons-container": "ButtonsContainer-module_buttons-container__291vm",
  "buttonsContainer": "ButtonsContainer-module_buttons-container__291vm",
  "mobile-full-size": "ButtonsContainer-module_mobile-full-size__39Byc",
  "mobileFullSize": "ButtonsContainer-module_mobile-full-size__39Byc",
  "center": "ButtonsContainer-module_center__2VoYH",
  "left": "ButtonsContainer-module_left__E6cA4",
  "right": "ButtonsContainer-module_right__1cNDA",
  "spacing-top-regular": "ButtonsContainer-module_spacing-top-regular__EBHBv",
  "spacingTopRegular": "ButtonsContainer-module_spacing-top-regular__EBHBv",
  "spacing-top-compact": "ButtonsContainer-module_spacing-top-compact__3faWD",
  "spacingTopCompact": "ButtonsContainer-module_spacing-top-compact__3faWD",
  "spacing-bottom-regular": "ButtonsContainer-module_spacing-bottom-regular__37REP",
  "spacingBottomRegular": "ButtonsContainer-module_spacing-bottom-regular__37REP",
  "spacing-bottom-compact": "ButtonsContainer-module_spacing-bottom-compact__3w0Ei",
  "spacingBottomCompact": "ButtonsContainer-module_spacing-bottom-compact__3w0Ei"
};

var ButtonsContainer = function ButtonsContainer(_ref4) {
  var _clsx3;

  var children = _ref4.children,
      spacingTop = _ref4.spacingTop,
      spacingBottom = _ref4.spacingBottom,
      _ref4$mobileFullSize = _ref4.mobileFullSize,
      mobileFullSize = _ref4$mobileFullSize === void 0 ? false : _ref4$mobileFullSize,
      _ref4$align = _ref4.align,
      align = _ref4$align === void 0 ? "center" : _ref4$align;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$t.buttonsContainer, (_clsx3 = {}, _clsx3[styles$t.left] = align == "left", _clsx3[styles$t.center] = align == "center", _clsx3[styles$t.right] = align == "right", _clsx3[styles$t.spacingTopRegular] = spacingTop == "regular", _clsx3[styles$t.spacingTopCompact] = spacingTop == "compact", _clsx3[styles$t.spacingBottomRegular] = spacingBottom == "regular", _clsx3[styles$t.spacingBottomCompact] = spacingBottom == "compact", _clsx3[styles$t.mobileFullSize] = mobileFullSize, _clsx3))
  }, children);
};

var styles$s = {
  "section-container": "SectionContainer-module_section-container__33v0P",
  "sectionContainer": "SectionContainer-module_section-container__33v0P",
  "background": "SectionContainer-module_background__31dMb",
  "background-neutral05": "SectionContainer-module_background-neutral05__z4dJ3",
  "backgroundNeutral05": "SectionContainer-module_background-neutral05__z4dJ3",
  "background-white": "SectionContainer-module_background-white__1cMZe",
  "backgroundWhite": "SectionContainer-module_background-white__1cMZe",
  "background-titanium": "SectionContainer-module_background-titanium__2wR1n",
  "backgroundTitanium": "SectionContainer-module_background-titanium__2wR1n",
  "background-neutral10": "SectionContainer-module_background-neutral10__115iw",
  "backgroundNeutral10": "SectionContainer-module_background-neutral10__115iw",
  "background-neutral35": "SectionContainer-module_background-neutral35__1xzON",
  "backgroundNeutral35": "SectionContainer-module_background-neutral35__1xzON",
  "background-neutral50": "SectionContainer-module_background-neutral50__34mRG",
  "backgroundNeutral50": "SectionContainer-module_background-neutral50__34mRG",
  "background-neutral60": "SectionContainer-module_background-neutral60__1xLBX",
  "backgroundNeutral60": "SectionContainer-module_background-neutral60__1xLBX",
  "background-neutral70": "SectionContainer-module_background-neutral70__3p03N",
  "backgroundNeutral70": "SectionContainer-module_background-neutral70__3p03N",
  "background-destination": "SectionContainer-module_background-destination__VkMas",
  "backgroundDestination": "SectionContainer-module_background-destination__VkMas",
  "background-destination-light": "SectionContainer-module_background-destination-light__3Q6uu",
  "backgroundDestinationLight": "SectionContainer-module_background-destination-light__3Q6uu",
  "background-destination-extralight": "SectionContainer-module_background-destination-extralight__2rFw9",
  "backgroundDestinationExtralight": "SectionContainer-module_background-destination-extralight__2rFw9",
  "background-transparent": "SectionContainer-module_background-transparent__1lSm0",
  "backgroundTransparent": "SectionContainer-module_background-transparent__1lSm0",
  "spacing-top-regular": "SectionContainer-module_spacing-top-regular__2-6qr",
  "spacingTopRegular": "SectionContainer-module_spacing-top-regular__2-6qr",
  "spacing-bottom-regular": "SectionContainer-module_spacing-bottom-regular__aSEWq",
  "spacingBottomRegular": "SectionContainer-module_spacing-bottom-regular__aSEWq",
  "spacing-top-compact": "SectionContainer-module_spacing-top-compact__1g1X3",
  "spacingTopCompact": "SectionContainer-module_spacing-top-compact__1g1X3",
  "spacing-bottom-compact": "SectionContainer-module_spacing-bottom-compact__22H2b",
  "spacingBottomCompact": "SectionContainer-module_spacing-bottom-compact__22H2b"
};

function capitalize(string) {
  if (!string) return undefined;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function stringPresent(content) {
  if (content == null || content == undefined) return false;
  return content.trim() != "";
}

var SectionContainer = function SectionContainer(_ref5) {
  var _clsx4, _clsx5;

  var className = _ref5.className,
      wrapperClassName = _ref5.wrapperClassName,
      _ref5$backgroundColor = _ref5.backgroundColor,
      backgroundColor = _ref5$backgroundColor === void 0 ? "white" : _ref5$backgroundColor,
      children = _ref5.children,
      _ref5$spacingTop = _ref5.spacingTop,
      spacingTop = _ref5$spacingTop === void 0 ? null : _ref5$spacingTop,
      _ref5$spacingBottom = _ref5.spacingBottom,
      spacingBottom = _ref5$spacingBottom === void 0 ? null : _ref5$spacingBottom,
      _ref5$dataContentName = _ref5.dataContentName,
      dataContentName = _ref5$dataContentName === void 0 ? null : _ref5$dataContentName;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(wrapperClassName, styles$s.background, (_clsx4 = {}, _clsx4[styles$s["background" + capitalize(backgroundColor)]] = true, _clsx4)),
    "data-content-name": dataContentName
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(className, styles$s.sectionContainer, (_clsx5 = {}, _clsx5[styles$s.spacingTopRegular] = spacingTop == "regular", _clsx5[styles$s.spacingBottomRegular] = spacingBottom == "regular", _clsx5[styles$s.spacingTopCompact] = spacingTop == "compact", _clsx5[styles$s.spacingBottomCompact] = spacingBottom == "compact", _clsx5))
  }, children));
};

var styles$r = {
  "logo-container": "Logo-module_logo-container__TT7Sp",
  "logoContainer": "Logo-module_logo-container__TT7Sp"
};
var base = "#323234";
var accent = "#ffbb4d";
var white = "#fcfcfd";
var titanium = "#323234";
var neutral70 = "#4b4b4e";
var neutral60 = "#646468";
var neutral50 = "#7d7d82";
var neutral35 = "#a4a4a8";
var neutral20 = "#D1D1D1";
var neutral10 = "#e5e5e6";
var neutral05 = "#f2f2f3";
var success = "#2bab6b";
var error = "#e02020";
var expeditions = "#c3002f";
var offer = "#f2b04d";
var yellow = "#ffbb4d";
var yellow_dark = "#ff9d00";
var yellow_light = "#ffebcc";
var colors = {
  base: base,
  accent: accent,
  white: white,
  titanium: titanium,
  neutral70: neutral70,
  neutral60: neutral60,
  neutral50: neutral50,
  neutral35: neutral35,
  neutral20: neutral20,
  neutral10: neutral10,
  neutral05: neutral05,
  success: success,
  error: error,
  expeditions: expeditions,
  offer: offer,
  yellow: yellow,
  yellow_dark: yellow_dark,
  yellow_light: yellow_light
};

var Logo = function Logo(_ref6) {
  var _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? 200 : _ref6$width,
      _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? "white" : _ref6$color;
  var colorCode = colors[color];
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Silversea Cruises",
    className: styles$r.logoContainer
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 356 40",
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: colorCode,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.1377143 30.6278261c-2.6125714-3.9269565-5.8371429-5.3652174-8.9588572-6.7530435-1.6628571-.7391304-3.2331428-1.4365217-4.6937142-2.4782609-1.0868572-.7791304-2.0725715-2.0591304-3.1148572-3.4173913-1.3851428-1.8034782-2.95885713-3.8486956-5.13599999-5.2086956l-.34628571-.2173913 9.8434286-7.3704348c2.244.93217391 3.9822857 3.20521739 5.5182857 5.2104348 1.0131428 1.3234782 1.968 2.573913 2.928 3.2591304.0737143.0521739 1.2531428.8104348 1.2531428.8104348l-3.2845714 2.5165217c-.384-.2260869-.7577143-.4660869-1.1245714-.7286956-1.6371429-1.1704348-3.2605714-4.3443478-5.1651429-5.5530435l-3.1885714 2.413913c2.292 1.5147827 3.5245714 4.3704348 5.1617143 5.5426087 4.2137143 3.012174 9.6908571 3.2382609 13.7245714 9.2869566 1.0508572-.8208696 2.1308572-1.6626087 3.1491429-2.4452174-2.712-4.0382609-6.0651429-5.4730435-9.2502857-6.8886957l6.024-4.7182608c-1.5497143-.6869566-3.0222858-1.3513044-4.3902858-2.3304348-1.1451428-.8191305-2.0965714-2.16000003-3.1011428-3.5808696-2.016-2.83826087-4.296-6.05391304-9.1405714-7.28-.2125715.47826087-.8571429 1.54434783-2.652 2.75826087l-12.85885719 10.04347823c4.25142858 1.32 6.41142858 4.3565218 8.32628572 7.0504348 1.008 1.4139131 1.96285717 2.7530435 3.07542857 3.5495652 1.4142857 1.0121739 2.9588571 1.6991305 4.596 2.4243479 3.1885714 1.4156521 6.4765714 2.8817391 9.1748571 6.9182608.36-.2834782.7422858-.5721739 1.1502858-.8695652.204-.1513043 1.1622857-.9078261 2.4805714-1.9443478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2342857 36.2243478c-2.6177143-3.9634782-5.856-5.4-8.9914286-6.7965217-1.6611428-.7339131-3.2314285-1.4330435-4.69199996-2.4782609-1.62171428-1.1617391-3.24514285-3.4834782-4.69371428-5.5965217l-3.85714286 2.9913043c1.06457143.9095652 1.88228571 1.9530435 2.61085714 2.8939131.71142857.9095652 1.38342857 1.7704348 2.14114286 2.3165217 1.31142857.9356522 2.83371429 1.6243478 4.44685714 2.3617391 3.45771426 1.5704348 7.36285716 3.3426087 10.05599996 8.0834783.0462858-.0956522.1114286-.1947826.1697143-.293913.264-.5634783.9702857-1.7165218 2.8097143-3.4817392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.2757174 34.5989249c2.9948565.90515 6.4348944 1.4010751 9.75 1.4010751 7.5188143 0 14.9742826-3.0102306 14.9742826-8.3648344 0-9.4797989-19.6266919-7.3764522-19.6266919-15.0407491 0-3.01023061 2.803059-4.90376278 7.6472658-4.90376278 4.5873037 0 7.4959394 1.3178429 8.1962642 4.20322528h1.4886302l-1.0188143-5.27483964c-2.5496751-.24796254-5.1626962-.61903936-7.7739577-.61903936-7.7739578 0-13.6369789 2.76053407-13.6369789 8.0769898 0 9.7242934 18.8612615 7.4596844 18.8612615 15.1222472 0 3.2547252-3.8236329 5.1083753-8.7294261 5.1083753-5.2911478 0-8.8138874-2.6356858-9.8978073-5.7256806h-1.5097455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.8065084 36c3.185576-.0419606 3.1363236 0 6.1934916 0v-29c-3.1855761.04021221-9.0061566.04021221-12 0v1.78332429c3.3755497.04021221 5.7977133.08217279 5.7977133 2.98969071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.828776 36h2.320921l17.850303-29c-1.94507.03936497-8.190771.03936497-10.638129 0v1.76286591c2.258567.08215298 6.420635-.70514636 5.040207 2.26091829l-11.563033 19.4839472-14.34987-23.5077314c-2.63615 0-7.54126.03936497-10.489175 0v1.76286591c4.139552 0 5.377954.96529745 7.068415 3.25017709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.046057 7c-6.030754.08217279-7.8813523.08217279-12.046057 0v1.78332429c4.9097508.12413336 5.9054346.29022729 5.9054346 3.69777541l.0051501 23.5189003c4.6024623-.0821728 20.3239653 0 26.5401213 0l2.549294-6.7101947h-1.500392c-2.423975 4.4460722-5.151805 4.3429191-11.24436 4.5492253h-10.209191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.531633 21.4982517c4.474988 0 7.183669 1.2255245 7.999019 3.3741259h1.450466l-.992153-5.31993-14.992153.0017482v-10.52097902l10.064002-.01398601c4.473271 0 7.176802 1.22552443 7.995586 3.37237763h1.450466l-.993869-5.3916084s-26.346984.08391608-30.512997.00174825v1.78321678c4.910986.12412588 5.904855.2902098 5.904855 3.69755247l-.048062 23.5174825c4.600294-.0821678 20.373467 0 26.589014 0l2.554193-6.715035-1.560324.0052448c-2.425453 4.4458042-5.092937 4.3356643-11.186611 4.5454545h-10.282001l.025748-12.3374126s6.176067-.020979 6.534821 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.532542 21.4982517c4.476924 0 7.182304 1.2255245 7.999412 3.3741259h1.450537l-.993919-5.31993-14.992888.0017482v-10.52097902l10.064496-.01398601c4.475207 0 7.177154 1.22552443 7.997694 3.37237763h1.452254l-.993918-5.3916084s-26.35171.08391608-30.51621.00174825v1.78321678c4.911227.12412588 5.905145.2902098 5.905145 3.69755247l-.048065 23.5174825c4.60052-.0821678 20.376183 0 26.593751 0l2.549169-6.715035-1.558684.0052448c-2.425572 4.4458042-5.094904 4.3356643-11.187159 4.5454545h-10.282506l.024033-12.3374126s6.178086-.020979 6.536858 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.553839 25.0808087 6.11183 10.9191913c2.64394 0 6.334331-.0052505 6.334331-.0052505l-16.397296-28.9947495-11.976823.03500302v1.71514786s7.312989-.53904647 4.691647 4.15660832l-12.317528 23.0932408c1.9521-.0420036 7.888363-.0420036 10.344568 0v-1.8044056c-2.268469-.0840072-6.311734.2817743-5.199228-2.0161738l3.6-7.0916113zm-13.781169-1.9391672 5.934525-12.0795413 6.737614 12.076041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.833649 14.0992874c0 2.945352-3.003792 5.7943043-10.695504 5.7943043-1.064023 0-2.376778-.0809068-3.316435-.2031277v-11.07562497c1.124479-.12394234 2.190229-.24616326 3.753445-.24616326 7.379068 0 10.258494 2.17071233 10.258494 5.73061163zm42.163638 13.3771653c-.274642-9.4058462-19.268143-7.3246478-19.268143-14.9316087 0-2.98666608 2.753332-4.86817961 7.506889-4.86817961 4.503097 0 7.361795 1.30828023 8.047537 4.17272531h1.463032l-1.000112-5.2365637c-2.5046-.24616325-5.067928-.612826-7.632984-.612826-7.631255 0-13.386652 2.74050278-13.386652 8.0183806 0 9.653731 18.366487 7.4055547 18.515036 15.0125156.07082 3.4996496-6.304682 6.0284176-13.832299 6.0989958-6.052494.0585284-11.211969-1.8883992-16.20735-6.7910072l-8.745371-7.4916257c4.979835-.6059403 8.883556-3.5151424 8.883556-6.9924135 0-2.9057592-2.630693-7.2420196-14.450676-7.2420196-4.002177 0-14.450676.04131411-17.88975 0v1.75584977c3.314708.04131412 5.689759.08262823 5.689759 2.94535193l-.027637 23.8537356c3.126431-.0413141 6.225226 0 6.126769 0l.032819-13.5011076h5.691487l8.026809 6.8151071c3.746536 3.1811866 7.46198 8.1681443 21.579285 8.5055429 8.978557.2117348 21.088728-2.1948122 20.877996-9.510853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.200366 9.7023128v-1.22372338h1.046027c.417678 0 1.035036 0 1.035036.57522327 0 .54224868-.33341.65765972-.813373.64850011zm1.747653.6466682c.762079-.0512938 1.168766-.37554386 1.168766-1.17059767 0-.45065262-.109915-.86833066-.500115-1.11930387-.32425-.18868789-.806045-.19784749-1.170597-.19784749h-2.092054v4.30867873h.846347v-1.8209297h.84818l.96359 1.8209297h.98191zm-.941607 3.651019c2.196473 0 3.993588-1.7989466 3.993588-4.00641172 0-2.19647356-1.797115-3.99358828-3.993588-3.99358828-2.216625 0-4.006412 1.79711472-4.006412 3.99358828 0 2.20746512 1.789787 4.00641172 4.006412 4.00641172zm0-.7529196c-1.809938 0-3.25166-1.443554-3.25166-3.25349212 0-1.79894665 1.441722-3.24066866 3.25166-3.24066866 1.797114 0 3.240668 1.44172201 3.240668 3.24066866 0 1.80993812-1.443554 3.25349212-3.240668 3.25349212z"
  }))));
};

function isNotNull(x) {
  return x !== null;
}

function isDefined(x) {
  return x !== undefined;
}

function isNotNullorUnDefined(x) {
  return isNotNull(x) && isDefined(x);
}

function isPresent(x) {
  return isNotNullorUnDefined(x);
}

var colorsDestinations = {
  "destinations-africa-indian-ocean-dark": "#8d3845",
  "destinations-africa-indian-ocean-light": "#d1b2af",
  "destinations-africa-indian-ocean-extralight": "#f6efef",
  "destinations-american-west-coast-dark": "#0c5a6a",
  "destinations-american-west-coast-light": "#b3d8da",
  "destinations-american-west-coast-extralight": "#eef6f7",
  "destinations-antarctica-dark": "#584b65",
  "destinations-antarctica-light": "#d9d3de",
  "destinations-antarctica-extralight": "#f2f0f4",
  "destinations-arctic-dark": "#597b91",
  "destinations-arctic-light": "#cdd6de",
  "destinations-arctic-extralight": "#f0f3f5",
  "destinations-asia-dark": "#926d5c",
  "destinations-asia-light": "#e3c7b8",
  "destinations-asia-extralight": "#f8f1ed",
  "destinations-australia-new-zeland-dark": "#789b4b",
  "destinations-australia-new-zeland-light": "#dbe9c8",
  "destinations-australia-new-zeland-extralight": "#f3f8ed",
  "destinations-canada-new-england-dark": "#1592ae",
  "destinations-canada-new-england-light": "#afdfe4",
  "destinations-canada-new-england-extralight": "#ecf7f9",
  "destinations-caribbean-central-america-dark": "#6b5da8",
  "destinations-caribbean-central-america-light": "#d3cee5",
  "destinations-caribbean-central-america-extralight": "#f0eef6",
  "destinations-galapagos-dark": "#a33c60",
  "destinations-galapagos-light": "#eac7d4",
  "destinations-galapagos-extralight": "#f8ecf1",
  "destinations-mediterranean-dark": "#83884f",
  "destinations-mediterranean-light": "#d1d3a9",
  "destinations-mediterranean-extralight": "#f2f2e9",
  "destinations-northern-eu-british-isles-dark": "#2b7354",
  "destinations-northern-eu-british-isles-light": "#b8cfbf",
  "destinations-northern-eu-british-isles-extralight": "#f0f5f1",
  "destinations-russian-far-east-dark": "#356696",
  "destinations-russian-far-east-light": "#b8c7db",
  "destinations-russian-far-east-extralight": "#eef2f6",
  "destinations-south-america-dark": "#9c4c9d",
  "destinations-south-america-light": "#e0c9e2",
  "destinations-south-america-extralight": "#f5eef6",
  "destinations-south-pacific-islands-dark": "#d4623b",
  "destinations-south-pacific-islands-light": "#eecec3",
  "destinations-south-pacific-islands-extralight": "#f9efeb",
  "destinations-special-voyage-dark": "#003a48",
  "destinations-special-voyage-light": "#acccdd",
  "destinations-special-voyage-extralight": "#d3e3ea",
  "destinations-transoceanic-dark": "#006d92",
  "destinations-transoceanic-light": "#a1c2ce",
  "destinations-transoceanic-extralight": "#eef4f6",
  "destinations-world-cruise-dark": "#a2b8a4",
  "destinations-world-cruise-light": "#d6e5d6",
  "destinations-world-cruise-extralight": "#e4ede4"
};
var destinationId2ColorMap = {
  1: "mediterranean",
  2: "northern-eu-british-isles",
  3: "africa-indian-ocean",
  5: "canada-new-england",
  6: "caribbean-central-america",
  7: "south-america",
  8: "transoceanic",
  9: "russian-far-east",
  10: "antarctica",
  11: "arctic",
  13: "asia",
  21: "russian-far-east",
  23: "galapagos",
  25: "australia-new-zeland",
  26: "south-pacific-islands",
  28: "american-west-coast",
  100: "special-voyage",
  101: "world-cruise"
};

var DestinationColor = function DestinationColor(_ref7) {
  var children = _ref7.children,
      _ref7$destinationId = _ref7.destinationId,
      destinationId = _ref7$destinationId === void 0 ? "" : _ref7$destinationId,
      _ref7$style = _ref7.style,
      style = _ref7$style === void 0 ? {} : _ref7$style,
      divProps = _objectWithoutPropertiesLoose(_ref7, ["children", "destinationId", "style"]);

  if (!isPresent(destinationId)) {
    return /*#__PURE__*/React.createElement("div", Object.assign({
      "data-testid": "container"
    }, divProps), children);
  }

  var destinationIdInt = parseInt(destinationId.toString(), 10);
  var prefix = "destinations-";
  var colorKey = "" + prefix + destinationId2ColorMap[destinationIdInt];
  var color = colorsDestinations[colorKey + "-dark"];
  var colorLight = colorsDestinations[colorKey + "-light"];
  var colorExtraLight = colorsDestinations[colorKey + "-extralight"];

  var colorStyle = _extends({
    "--destination-color": color,
    "--destination-color-light": colorLight,
    "--destination-color-extralight": colorExtraLight
  }, style);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-testid": "container",
    style: destinationId ? colorStyle : undefined
  }, divProps), children);
};

var styles$q = {
  "section-divider": "SectionDivider-module_section-divider__3f9W1",
  "sectionDivider": "SectionDivider-module_section-divider__3f9W1",
  "background-top-neutral05": "SectionDivider-module_background-top-neutral05__a7hi_",
  "backgroundTopNeutral05": "SectionDivider-module_background-top-neutral05__a7hi_",
  "background-top-white": "SectionDivider-module_background-top-white__1FQ7q",
  "backgroundTopWhite": "SectionDivider-module_background-top-white__1FQ7q",
  "background-top-titanium": "SectionDivider-module_background-top-titanium__b1Zs4",
  "backgroundTopTitanium": "SectionDivider-module_background-top-titanium__b1Zs4",
  "background-top-neutral10": "SectionDivider-module_background-top-neutral10__cYEaI",
  "backgroundTopNeutral10": "SectionDivider-module_background-top-neutral10__cYEaI",
  "background-top-neutral35": "SectionDivider-module_background-top-neutral35__19w0o",
  "backgroundTopNeutral35": "SectionDivider-module_background-top-neutral35__19w0o",
  "background-top-neutral50": "SectionDivider-module_background-top-neutral50__1T1xc",
  "backgroundTopNeutral50": "SectionDivider-module_background-top-neutral50__1T1xc",
  "background-top-neutral60": "SectionDivider-module_background-top-neutral60__2_bV1",
  "backgroundTopNeutral60": "SectionDivider-module_background-top-neutral60__2_bV1",
  "background-top-neutral70": "SectionDivider-module_background-top-neutral70__Ldhzp",
  "backgroundTopNeutral70": "SectionDivider-module_background-top-neutral70__Ldhzp",
  "background-top-destination": "SectionDivider-module_background-top-destination__2Y9Ee",
  "backgroundTopDestination": "SectionDivider-module_background-top-destination__2Y9Ee",
  "background-top-destination-light": "SectionDivider-module_background-top-destination-light__182x6",
  "backgroundTopDestinationLight": "SectionDivider-module_background-top-destination-light__182x6",
  "background-top-destination-extralight": "SectionDivider-module_background-top-destination-extralight__dln9S",
  "backgroundTopDestinationExtralight": "SectionDivider-module_background-top-destination-extralight__dln9S",
  "background-top-transparent": "SectionDivider-module_background-top-transparent__eKn7q",
  "backgroundTopTransparent": "SectionDivider-module_background-top-transparent__eKn7q",
  "background-bottom-neutral05": "SectionDivider-module_background-bottom-neutral05__bsxby",
  "backgroundBottomNeutral05": "SectionDivider-module_background-bottom-neutral05__bsxby",
  "background-bottom-white": "SectionDivider-module_background-bottom-white__2sQ8c",
  "backgroundBottomWhite": "SectionDivider-module_background-bottom-white__2sQ8c",
  "background-bottom-titanium": "SectionDivider-module_background-bottom-titanium__3IaKW",
  "backgroundBottomTitanium": "SectionDivider-module_background-bottom-titanium__3IaKW",
  "background-bottom-neutral10": "SectionDivider-module_background-bottom-neutral10__oXzkE",
  "backgroundBottomNeutral10": "SectionDivider-module_background-bottom-neutral10__oXzkE",
  "background-bottom-neutral35": "SectionDivider-module_background-bottom-neutral35__3gBuY",
  "backgroundBottomNeutral35": "SectionDivider-module_background-bottom-neutral35__3gBuY",
  "background-bottom-neutral50": "SectionDivider-module_background-bottom-neutral50__2Z6ao",
  "backgroundBottomNeutral50": "SectionDivider-module_background-bottom-neutral50__2Z6ao",
  "background-bottom-neutral60": "SectionDivider-module_background-bottom-neutral60__2FFzA",
  "backgroundBottomNeutral60": "SectionDivider-module_background-bottom-neutral60__2FFzA",
  "background-bottom-neutral70": "SectionDivider-module_background-bottom-neutral70__1XlTo",
  "backgroundBottomNeutral70": "SectionDivider-module_background-bottom-neutral70__1XlTo",
  "background-bottom-destination": "SectionDivider-module_background-bottom-destination__2958S",
  "backgroundBottomDestination": "SectionDivider-module_background-bottom-destination__2958S",
  "background-bottom-destination-light": "SectionDivider-module_background-bottom-destination-light__18Mb7",
  "backgroundBottomDestinationLight": "SectionDivider-module_background-bottom-destination-light__18Mb7",
  "background-bottom-destination-extralight": "SectionDivider-module_background-bottom-destination-extralight__2eF6i",
  "backgroundBottomDestinationExtralight": "SectionDivider-module_background-bottom-destination-extralight__2eF6i",
  "background-bottom-transparent": "SectionDivider-module_background-bottom-transparent__3woNm",
  "backgroundBottomTransparent": "SectionDivider-module_background-bottom-transparent__3woNm",
  "spacing-top-regular": "SectionDivider-module_spacing-top-regular__2ueuu",
  "spacingTopRegular": "SectionDivider-module_spacing-top-regular__2ueuu",
  "spacing-bottom-regular": "SectionDivider-module_spacing-bottom-regular__3aSR2",
  "spacingBottomRegular": "SectionDivider-module_spacing-bottom-regular__3aSR2",
  "spacing-top-compact": "SectionDivider-module_spacing-top-compact__zYped",
  "spacingTopCompact": "SectionDivider-module_spacing-top-compact__zYped",
  "spacing-bottom-compact": "SectionDivider-module_spacing-bottom-compact__2Z2rT",
  "spacingBottomCompact": "SectionDivider-module_spacing-bottom-compact__2Z2rT"
};

var SectionDivider = function SectionDivider(_ref8) {
  var _clsx6;

  var className = _ref8.className,
      _ref8$backgroundColor = _ref8.backgroundColorTop,
      backgroundColorTop = _ref8$backgroundColor === void 0 ? "transparent" : _ref8$backgroundColor,
      _ref8$backgroundColor2 = _ref8.backgroundColorBottom,
      backgroundColorBottom = _ref8$backgroundColor2 === void 0 ? "transparent" : _ref8$backgroundColor2,
      _ref8$spacingTop = _ref8.spacingTop,
      spacingTop = _ref8$spacingTop === void 0 ? null : _ref8$spacingTop,
      _ref8$spacingBottom = _ref8.spacingBottom,
      spacingBottom = _ref8$spacingBottom === void 0 ? null : _ref8$spacingBottom,
      children = _ref8.children,
      _ref8$dataContentName = _ref8.dataContentName,
      dataContentName = _ref8$dataContentName === void 0 ? null : _ref8$dataContentName;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(className, (_clsx6 = {}, _clsx6[styles$q["backgroundTop" + capitalize(backgroundColorTop)]] = true, _clsx6[styles$q["backgroundBottom" + capitalize(backgroundColorBottom)]] = true, _clsx6[styles$q.sectionDivider] = true, _clsx6[styles$q.spacingTopRegular] = spacingTop == "regular", _clsx6[styles$q.spacingBottomRegular] = spacingBottom == "regular", _clsx6[styles$q.spacingTopCompact] = spacingTop == "compact", _clsx6[styles$q.spacingBottomCompact] = spacingBottom == "compact", _clsx6)),
    "data-content-name": dataContentName
  }, children);
};

var styles$p = {
  "section-title": "SectionTitle-module_section-title__3CKOF",
  "sectionTitle": "SectionTitle-module_section-title__3CKOF",
  "text-color-titaium": "SectionTitle-module_text-color-titaium__2Zg0b",
  "textColorTitaium": "SectionTitle-module_text-color-titaium__2Zg0b",
  "text-color-white": "SectionTitle-module_text-color-white__29uSJ",
  "textColorWhite": "SectionTitle-module_text-color-white__29uSJ",
  "heading": "SectionTitle-module_heading__mX_r0",
  "tagline": "SectionTitle-module_tagline__ZAx-m",
  "body": "SectionTitle-module_body__21jPz",
  "variant-wide": "SectionTitle-module_variant-wide__QuqCQ",
  "variantWide": "SectionTitle-module_variant-wide__QuqCQ",
  "variant-column": "SectionTitle-module_variant-column__KISKl",
  "variantColumn": "SectionTitle-module_variant-column__KISKl"
};

var SectionTitleBody = function SectionTitleBody(_ref9) {
  var _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? undefined : _ref9$className,
      children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, ["className", "children"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx(styles$p.body, className)
  }, props), children);
};

var SectionTitleHeading = function SectionTitleHeading(_ref10) {
  var children = _ref10.children,
      className = _ref10.className,
      tagline = _ref10.tagline,
      _ref10$priority = _ref10.priority,
      priority = _ref10$priority === void 0 ? 2 : _ref10$priority;
  var TitleTag = "h" + priority;
  var TaglineTag = "h" + (priority + 2);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$p.heading, className)
  }, stringPresent(tagline) && /*#__PURE__*/React.createElement(TaglineTag, {
    className: styles$p.tagline
  }, tagline), /*#__PURE__*/React.createElement(TitleTag, null, children));
};

var SectionTitle = function SectionTitle(_ref11) {
  var _clsx7;

  var variant = _ref11.variant,
      textColor = _ref11.textColor,
      className = _ref11.className,
      children = _ref11.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$p.sectionTitle, className, (_clsx7 = {}, _clsx7[styles$p.variantWide] = variant == "wide", _clsx7[styles$p.variantColumn] = variant == "column", _clsx7[styles$p.textColorTitanium] = textColor == "titanium", _clsx7[styles$p.textColorWhite] = textColor == "white", _clsx7))
  }, children);
};

var styles$o = {
  "container": "TextStyle-module_container__1hnlj",
  "font-size-small": "TextStyle-module_font-size-small__1YHjK",
  "fontSizeSmall": "TextStyle-module_font-size-small__1YHjK",
  "font-size-medium": "TextStyle-module_font-size-medium__35GJL",
  "fontSizeMedium": "TextStyle-module_font-size-medium__35GJL",
  "font-size-large": "TextStyle-module_font-size-large__1CRuj",
  "fontSizeLarge": "TextStyle-module_font-size-large__1CRuj",
  "font-size-disclaimer": "TextStyle-module_font-size-disclaimer__1w75N",
  "fontSizeDisclaimer": "TextStyle-module_font-size-disclaimer__1w75N",
  "text-align-left": "TextStyle-module_text-align-left__2B27_",
  "textAlignLeft": "TextStyle-module_text-align-left__2B27_",
  "text-align-center": "TextStyle-module_text-align-center__3aeri",
  "textAlignCenter": "TextStyle-module_text-align-center__3aeri",
  "text-align-right": "TextStyle-module_text-align-right__1Ct6W",
  "textAlignRight": "TextStyle-module_text-align-right__1Ct6W",
  "is-responsive": "TextStyle-module_is-responsive__34s7k",
  "isResponsive": "TextStyle-module_is-responsive__34s7k",
  "is-boxed": "TextStyle-module_is-boxed__AMnR-",
  "isBoxed": "TextStyle-module_is-boxed__AMnR-"
};

var TextStyle = function TextStyle(_ref12) {
  var _clsx8;

  var _ref12$boxed = _ref12.boxed,
      boxed = _ref12$boxed === void 0 ? false : _ref12$boxed,
      _ref12$fontSize = _ref12.fontSize,
      fontSize = _ref12$fontSize === void 0 ? "medium" : _ref12$fontSize,
      textAlign = _ref12.textAlign,
      _ref12$fontSizeRespon = _ref12.fontSizeResponsive,
      fontSizeResponsive = _ref12$fontSizeRespon === void 0 ? false : _ref12$fontSizeRespon,
      children = _ref12.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$o.container, (_clsx8 = {}, _clsx8[styles$o.isBoxed] = boxed, _clsx8[styles$o.isResponsive] = fontSizeResponsive, _clsx8[styles$o.fontSizeSmall] = fontSize == "small", _clsx8[styles$o.fontSizeMedium] = fontSize == "medium", _clsx8[styles$o.fontSizeLarge] = fontSize == "large", _clsx8[styles$o.fontSizeDisclaimer] = fontSize == "disclaimer", _clsx8[styles$o.textAlignLeft] = textAlign == "left", _clsx8[styles$o.textAlignCenter] = textAlign == "center", _clsx8[styles$o.textAlignRight] = textAlign == "right", _clsx8))
  }, children);
};

var styles$n = {
  "description-text": "DescriptionText-module_description-text__3OHtS",
  "descriptionText": "DescriptionText-module_description-text__3OHtS",
  "lead-in": "DescriptionText-module_lead-in__2SjXF",
  "leadIn": "DescriptionText-module_lead-in__2SjXF",
  "content": "DescriptionText-module_content__3RaUj"
};

var DescriptionTextLeadIn = function DescriptionTextLeadIn(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$n.leadIn
  }, props.children);
};

var DescriptionTextContent = function DescriptionTextContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$n.content
  }, props.children);
};

var DescriptionText = function DescriptionText(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$n.descriptionText,
    "data-content-name": "description_text"
  }, props.children);
};

var styles$m = {
  "title": "DescriptionTextColumn-module_title__38snt",
  "leadIn": "DescriptionTextColumn-module_leadIn__3w-jd",
  "content-container": "DescriptionTextColumn-module_content-container__1Sqco",
  "contentContainer": "DescriptionTextColumn-module_content-container__1Sqco",
  "content-left": "DescriptionTextColumn-module_content-left__2Me24",
  "contentLeft": "DescriptionTextColumn-module_content-left__2Me24",
  "content-right": "DescriptionTextColumn-module_content-right__nXcPh",
  "contentRight": "DescriptionTextColumn-module_content-right__nXcPh"
};

var DescriptionTextColumnTitle = function DescriptionTextColumnTitle(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.title
  }, props.children);
};

var DescriptionTextColumnLeadIn = function DescriptionTextColumnLeadIn(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.leadIn
  }, props.children);
};

var DescriptionTextColumnContentLeft = function DescriptionTextColumnContentLeft(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.contentLeft
  }, props.children);
};

var DescriptionTextColumnContentRight = function DescriptionTextColumnContentRight(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.contentRight
  }, props.children);
};

var DescriptionTextColumnContent = function DescriptionTextColumnContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.contentContainer
  }, props.children);
};

var DescriptionTextColumn = function DescriptionTextColumn(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.descriptionText
  }, props.children);
};

var styles$l = {
  "wrapper": "InlineFormContainer-module_wrapper__3-a7k",
  "container": "InlineFormContainer-module_container__3T2Jp"
};

var InlineFormContainer = function InlineFormContainer(_ref13) {
  var children = _ref13.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$l.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.container
  }, children));
};

var styles$k = {
  "container": "InputForm-module_container__nAX66",
  "submit-button": "InputForm-module_submit-button__3havX",
  "submitButton": "InputForm-module_submit-button__3havX",
  "submit-button-no-action-cursor": "InputForm-module_submit-button-no-action-cursor__9bzjR",
  "submitButtonNoActionCursor": "InputForm-module_submit-button-no-action-cursor__9bzjR",
  "input": "InputForm-module_input__2OXqK",
  "button-variant-white": "InputForm-module_button-variant-white__1fVcK",
  "buttonVariantWhite": "InputForm-module_button-variant-white__1fVcK"
};
var styles$j = {
  "input": "InputText-module_input__MmhOX",
  "input-default": "InputText-module_input-default__3fCVh",
  "inputDefault": "InputText-module_input-default__3fCVh",
  "input-transparent": "InputText-module_input-transparent__2_wq_",
  "inputTransparent": "InputText-module_input-transparent__2_wq_",
  "state-invalid": "InputText-module_state-invalid__20826",
  "stateInvalid": "InputText-module_state-invalid__20826",
  "state-valid": "InputText-module_state-valid__2RU3A",
  "stateValid": "InputText-module_state-valid__2RU3A"
};

var InputTextBase = function InputTextBase(props, ref) {
  var _clsx9;

  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? "default" : _props$variant,
      className = props.className,
      _props$isValid = props.isValid,
      isValid = _props$isValid === void 0 ? null : _props$isValid,
      _props$hasError = props.hasError,
      hasError = _props$hasError === void 0 ? false : _props$hasError,
      inputProps = _objectWithoutPropertiesLoose(props, ["variant", "className", "isValid", "hasError"]);

  return /*#__PURE__*/React.createElement("input", Object.assign({
    ref: ref
  }, inputProps, {
    "aria-invalid": hasError,
    className: clsx(className, styles$j.input, (_clsx9 = {}, _clsx9[styles$j.inputDefault] = variant == "default", _clsx9[styles$j.inputTransparent] = variant == "transparent", _clsx9[styles$j.stateValid] = !hasError && isValid, _clsx9[styles$j.stateInvalid] = hasError == true, _clsx9))
  }));
};

var InputText = /*#__PURE__*/React.forwardRef(InputTextBase);

var FormWrap = function FormWrap(_ref14) {
  var condition = _ref14.condition,
      children = _ref14.children,
      props = _ref14.props;
  return condition ? /*#__PURE__*/React.createElement("form", {
    className: clsx(styles$k.container, props.className),
    action: props.formAction,
    onSubmit: props.onSubmitAction
  }, children) : /*#__PURE__*/React.createElement("div", {
    className: styles$k.container
  }, children);
};

var InputForm = function InputForm(_ref15) {
  var _clsx10;

  var placeholder = _ref15.placeholder,
      _ref15$formAction = _ref15.formAction,
      formAction = _ref15$formAction === void 0 ? undefined : _ref15$formAction,
      className = _ref15.className,
      _ref15$inputType = _ref15.inputType,
      inputType = _ref15$inputType === void 0 ? "text" : _ref15$inputType,
      _ref15$icon = _ref15.icon,
      icon = _ref15$icon === void 0 ? "action" : _ref15$icon,
      _ref15$onSubmitAction = _ref15.onSubmitAction,
      onSubmitAction = _ref15$onSubmitAction === void 0 ? undefined : _ref15$onSubmitAction,
      _ref15$buttonVariant = _ref15.buttonVariant,
      buttonVariant = _ref15$buttonVariant === void 0 ? "transparent" : _ref15$buttonVariant,
      dataContentPiece = _ref15.dataContentPiece,
      inputProps = _objectWithoutPropertiesLoose(_ref15, ["placeholder", "formAction", "className", "inputType", "icon", "onSubmitAction", "buttonVariant", "dataContentPiece"]);

  var iconName = icon ? icon == "action" ? "chevron-right" : "search" : undefined;
  var dataContentPieceValue = dataContentPiece || inputProps["data-content-piece"];
  return /*#__PURE__*/React.createElement(FormWrap, {
    condition: !!formAction,
    props: {
      formAction: formAction,
      onSubmitAction: onSubmitAction,
      className: className
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputText, Object.assign({
    className: styles$k.input,
    type: inputType,
    placeholder: placeholder
  }, inputProps)), /*#__PURE__*/React.createElement("button", {
    className: clsx(styles$k.submitButton, (_clsx10 = {}, _clsx10[styles$k.buttonVariantWhite] = buttonVariant == "white", _clsx10[styles$k.submitButtonNoActionCursor] = !formAction && !onSubmitAction, _clsx10)),
    "aria-label": placeholder,
    "data-content-piece": dataContentPieceValue
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: "1.5x",
    padding: false
  }))));
};

var styles$i = {
  "field": "FloatLabel-module_field__1V6Q9",
  "label": "FloatLabel-module_label__2TpsC",
  "input": "FloatLabel-module_input__CiRkB",
  "force-focus": "FloatLabel-module_force-focus__3AKFs",
  "forceFocus": "FloatLabel-module_force-focus__3AKFs"
};

var FloatLabel = function FloatLabel(_ref16) {
  var _clsx11;

  var id = _ref16.id,
      label = _ref16.label,
      children = _ref16.children,
      _ref16$placeholder = _ref16.placeholder,
      placeholder = _ref16$placeholder === void 0 ? " " : _ref16$placeholder,
      forceFocus = _ref16.forceFocus,
      inputProps = _objectWithoutPropertiesLoose(_ref16, ["id", "label", "children", "placeholder", "forceFocus"]);

  return /*#__PURE__*/React.createElement("div", {
    className: styles$i.field
  }, /*#__PURE__*/React.cloneElement(children, _extends({
    className: children.props.className + " " + styles$i.input,
    id: id,
    placeholder: placeholder
  }, inputProps)), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: clsx(styles$i.label, (_clsx11 = {}, _clsx11[styles$i.forceFocus] = forceFocus, _clsx11))
  }, label));
};

var styles$h = {
  "input-checkbox": "InputCheckbox-module_input-checkbox__XkyzU",
  "inputCheckbox": "InputCheckbox-module_input-checkbox__XkyzU",
  "width-full": "InputCheckbox-module_width-full__28ZPW",
  "widthFull": "InputCheckbox-module_width-full__28ZPW",
  "position-left": "InputCheckbox-module_position-left__1jPRM",
  "positionLeft": "InputCheckbox-module_position-left__1jPRM",
  "position-right": "InputCheckbox-module_position-right___2kGY",
  "positionRight": "InputCheckbox-module_position-right___2kGY"
};

var InputCheckboxBase = function InputCheckboxBase(_ref17, ref) {
  var _clsx12;

  var _ref17$position = _ref17.position,
      position = _ref17$position === void 0 ? "Left" : _ref17$position,
      _ref17$width = _ref17.width,
      width = _ref17$width === void 0 ? "auto" : _ref17$width,
      children = _ref17.children,
      _ref17$reverseValue = _ref17.reverseValue,
      reverseValue = _ref17$reverseValue === void 0 ? "" : _ref17$reverseValue,
      inputProps = _objectWithoutPropertiesLoose(_ref17, ["position", "width", "children", "reverseValue"]);

  var label = /*#__PURE__*/React.createElement("label", {
    htmlFor: inputProps.id
  }, children);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$h.inputCheckbox, (_clsx12 = {}, _clsx12[styles$h.positionLeft] = position == "Left", _clsx12[styles$h.positionRight] = position == "Right", _clsx12[styles$h.widthFull] = width == "full", _clsx12))
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: inputProps.name,
    value: reverseValue
  }), position == "Right" ? label : "", /*#__PURE__*/React.createElement("input", Object.assign({
    type: "checkbox",
    ref: ref
  }, inputProps)), position == "Left" ? label : "");
};

var InputCheckbox = /*#__PURE__*/React.forwardRef(InputCheckboxBase);
var styles$g = {
  "error": "InputWithError-module_error__15ukN"
};

var InputWithError = function InputWithError(_ref18) {
  var name = _ref18.name,
      label = _ref18.label,
      id = _ref18.id,
      children = _ref18.children,
      _ref18$forceLabelRend = _ref18.forceLabelRenderAsFocused,
      forceLabelRenderAsFocused = _ref18$forceLabelRend === void 0 ? false : _ref18$forceLabelRend,
      isTouched = _ref18.isTouched,
      hasError = _ref18.hasError,
      errorMessageComponent = _ref18.errorMessageComponent;
  var isValid = isTouched && !hasError;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$g.inputWithError,
    "data-controlled-input": true
  }, /*#__PURE__*/React.createElement(FloatLabel, {
    label: label,
    id: id,
    forceFocus: forceLabelRenderAsFocused
  }, /*#__PURE__*/React.cloneElement(children, {
    id: id,
    name: name,
    isValid: isValid,
    hasError: isTouched && hasError
  })), hasError && errorMessageComponent && /*#__PURE__*/React.createElement("div", {
    className: styles$g.error
  }, errorMessageComponent));
};

var styles$f = {
  "wrapper": "CountrySelect-module_wrapper__1M21u",
  "select": "CountrySelect-module_select__2HFL3",
  "selected-country": "CountrySelect-module_selected-country__3_F3D",
  "selectedCountry": "CountrySelect-module_selected-country__3_F3D",
  "icon": "CountrySelect-module_icon__aesgO",
  "country-icon": "CountrySelect-module_country-icon__3fDmh",
  "countryIcon": "CountrySelect-module_country-icon__3fDmh",
  "PhoneInputInternationalIconGlobe": "CountrySelect-module_PhoneInputInternationalIconGlobe__3sOUN",
  "phoneInputInternationalIconGlobe": "CountrySelect-module_PhoneInputInternationalIconGlobe__3sOUN"
};
var styles$e = {
  "select": "Select-module_select__2Zdbb",
  "select-default": "Select-module_select-default__1Tct0",
  "selectDefault": "Select-module_select-default__1Tct0",
  "select-transparent": "Select-module_select-transparent__1Sr3P",
  "selectTransparent": "Select-module_select-transparent__1Sr3P",
  "state-invalid": "Select-module_state-invalid__2o_h8",
  "stateInvalid": "Select-module_state-invalid__2o_h8",
  "state-valid": "Select-module_state-valid__13pKG",
  "stateValid": "Select-module_state-valid__13pKG"
};

var SelectBase = function SelectBase(props, ref) {
  var _clsx13;

  var _props$isValid2 = props.isValid,
      isValid = _props$isValid2 === void 0 ? null : _props$isValid2,
      _props$hasError2 = props.hasError,
      hasError = _props$hasError2 === void 0 ? false : _props$hasError2,
      _props$variant2 = props.variant,
      variant = _props$variant2 === void 0 ? "default" : _props$variant2,
      className = props.className,
      children = props.children,
      defaultValue = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, ["isValid", "hasError", "variant", "className", "children", "value"]);

  var _useState = useState(defaultValue || ""),
      value = _useState[0],
      setValue = _useState[1];

  var internalOnChange = function internalOnChange(e) {
    setValue(e.target.value);
    if (props.onChange) props.onChange(e);
  };

  return /*#__PURE__*/React.createElement("select", Object.assign({
    ref: ref
  }, otherProps, {
    "data-value": value,
    onChange: function onChange(e) {
      return internalOnChange(e);
    },
    "aria-invalid": hasError,
    className: clsx(className, styles$e.select, (_clsx13 = {}, _clsx13[styles$e.selectDefault] = variant == "default", _clsx13[styles$e.selectTransparent] = variant == "transparent", _clsx13[styles$e.stateValid] = !hasError && isValid, _clsx13[styles$e.stateInvalid] = hasError == true, _clsx13))
  }), children);
};

var Select = /*#__PURE__*/forwardRef(SelectBase);
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */

function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */


function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}

var COUNTRIES = ["AC", "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TA", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XK", "YE", "YT", "ZA", "ZM", "ZW"];

function hasFlag(country) {
  return COUNTRIES.indexOf(country) >= 0;
}

var CountrySelect = function CountrySelect(props, ref) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var options = props.options,
      _onChange = props.onChange,
      value = props.value,
      iconComponent = props.iconComponent,
      selectProps = _objectWithoutPropertiesLoose(props, ["options", "onChange", "value", "iconComponent"]);

  var icon = hasFlag(value) ? getCountryFlag(value) : undefined;
  var countryCallingCode = undefined;

  try {
    countryCallingCode = value ? getCountryCallingCode(value) : undefined;
  } catch (_unused) {
    countryCallingCode = undefined;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$f.wrapper
  }, /*#__PURE__*/React.createElement(Select, Object.assign({
    ref: ref
  }, selectProps, {
    value: value,
    className: styles$f.select,
    onChange: function onChange(e) {
      if (_onChange) _onChange(e.target.value);
    }
  }), options == null ? void 0 : options.map(function (o) {
    return /*#__PURE__*/React.createElement("option", {
      key: o.label,
      value: o.value
    }, o.label);
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$f.selectedCountry
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: styles$f.icon
  }, icon), " ", countryCallingCode && "+" + countryCallingCode));
};

var CountrySelect$1 = /*#__PURE__*/React.forwardRef(CountrySelect);
var styles$d = {
  "input": "PhoneInput-module_input__3nGtX"
};
var Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  return /*#__PURE__*/React.createElement(InputText, Object.assign({}, props, {
    ref: ref,
    variant: "default"
  }));
});

var PhoneInput = function PhoneInput(_ref19) {
  var _ref19$value = _ref19.value,
      defaultValue = _ref19$value === void 0 ? "" : _ref19$value,
      country = _ref19.country,
      onChange = _ref19.onChange,
      onBlur = _ref19.onBlur,
      className = _ref19.className,
      _ref19$isValid = _ref19.isValid,
      isValid = _ref19$isValid === void 0 ? null : _ref19$isValid,
      _ref19$hasError = _ref19.hasError,
      hasError = _ref19$hasError === void 0 ? false : _ref19$hasError,
      props = _objectWithoutPropertiesLoose(_ref19, ["value", "country", "onChange", "onBlur", "className", "isValid", "hasError"]);

  var _useState2 = useState(defaultValue || ""),
      value = _useState2[0],
      setValue = _useState2[1];

  var internalOnChange = function internalOnChange(phoneNumber) {
    setValue(phoneNumber);
    if (onChange) onChange(phoneNumber);
  };

  return /*#__PURE__*/React.createElement(PhoneInputComponent, Object.assign({
    placeholder: "Enter phone number",
    value: value,
    //onBlur={onBlur}
    onChange: internalOnChange,
    defaultCountry: country,
    international: false,
    // showCountrySelect={true}
    //useNationalFormatForDefaultCountryValue={true}
    inputComponent: Input,
    //isValid={isValid}
    //hasError={hasError}
    countrySelectComponent: CountrySelect$1,
    countrySelectProps: {
      isValid: isValid,
      hasError: hasError
    },
    className: clsx([styles$d.input, className]),
    "data-testid": "phone-input"
  }, props));
};

var styles$c = {
  "input": "TextArea-module_input__3ZVUo",
  "input-default": "TextArea-module_input-default__3XmO6",
  "inputDefault": "TextArea-module_input-default__3XmO6",
  "input-transparent": "TextArea-module_input-transparent__3Sl-r",
  "inputTransparent": "TextArea-module_input-transparent__3Sl-r",
  "state-invalid": "TextArea-module_state-invalid__1pFni",
  "stateInvalid": "TextArea-module_state-invalid__1pFni",
  "state-valid": "TextArea-module_state-valid__2whkS",
  "stateValid": "TextArea-module_state-valid__2whkS"
};

var TextAreaBase = function TextAreaBase(props, ref) {
  var _clsx14;

  var _props$variant3 = props.variant,
      variant = _props$variant3 === void 0 ? "default" : _props$variant3,
      className = props.className,
      _props$isValid3 = props.isValid,
      isValid = _props$isValid3 === void 0 ? null : _props$isValid3,
      _props$hasError3 = props.hasError,
      hasError = _props$hasError3 === void 0 ? false : _props$hasError3,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 3 : _props$rows,
      inputProps = _objectWithoutPropertiesLoose(props, ["variant", "className", "isValid", "hasError", "rows"]);

  return /*#__PURE__*/React.createElement("textarea", Object.assign({
    ref: ref
  }, inputProps, {
    rows: rows,
    "aria-invalid": hasError,
    className: clsx(className, styles$c.input, (_clsx14 = {}, _clsx14[styles$c.inputDefault] = variant == "default", _clsx14[styles$c.inputTransparent] = variant == "transparent", _clsx14[styles$c.stateValid] = !hasError && isValid, _clsx14[styles$c.stateInvalid] = hasError == true, _clsx14))
  }));
};

var TextArea = /*#__PURE__*/React.forwardRef(TextAreaBase);
var styles$b = {
  "label": "DropDown-module_label__15S8m",
  "button": "DropDown-module_button__2zcd8",
  "icon": "DropDown-module_icon__2roYz",
  "content": "DropDown-module_content__3rq2x",
  "drop-down": "DropDown-module_drop-down__21Fxf",
  "dropDown": "DropDown-module_drop-down__21Fxf",
  "mobile-expand-open": "DropDown-module_mobile-expand-open__2s-HI",
  "mobileExpandOpen": "DropDown-module_mobile-expand-open__2s-HI",
  "content-wrapper": "DropDown-module_content-wrapper__1i9Ku",
  "contentWrapper": "DropDown-module_content-wrapper__1i9Ku",
  "tablet-expand-open": "DropDown-module_tablet-expand-open__1V614",
  "tabletExpandOpen": "DropDown-module_tablet-expand-open__1V614",
  "desktop-expand-open": "DropDown-module_desktop-expand-open__5w3uH",
  "desktopExpandOpen": "DropDown-module_desktop-expand-open__5w3uH",
  "mobile-expand-inline": "DropDown-module_mobile-expand-inline__2g1g8",
  "mobileExpandInline": "DropDown-module_mobile-expand-inline__2g1g8",
  "drop-down-open": "DropDown-module_drop-down-open__2DCaS",
  "dropDownOpen": "DropDown-module_drop-down-open__2DCaS",
  "tablet-expand-inline": "DropDown-module_tablet-expand-inline__2Z2GY",
  "tabletExpandInline": "DropDown-module_tablet-expand-inline__2Z2GY",
  "desktop-expand-inline": "DropDown-module_desktop-expand-inline__3hMwD",
  "desktopExpandInline": "DropDown-module_desktop-expand-inline__3hMwD",
  "mobile-expand-absolute": "DropDown-module_mobile-expand-absolute__3gw4B",
  "mobileExpandAbsolute": "DropDown-module_mobile-expand-absolute__3gw4B",
  "tablet-expand-absolute": "DropDown-module_tablet-expand-absolute__1sGb4",
  "tabletExpandAbsolute": "DropDown-module_tablet-expand-absolute__1sGb4",
  "desktop-expand-absolute": "DropDown-module_desktop-expand-absolute__2E6Eo",
  "desktopExpandAbsolute": "DropDown-module_desktop-expand-absolute__2E6Eo",
  "drop-down-default": "DropDown-module_drop-down-default__2Ryi-",
  "dropDownDefault": "DropDown-module_drop-down-default__2Ryi-",
  "drop-down-transparent": "DropDown-module_drop-down-transparent__38dIw",
  "dropDownTransparent": "DropDown-module_drop-down-transparent__38dIw"
};

var DropDown = function DropDown(_ref20) {
  var _clsx15;

  var label = _ref20.label,
      children = _ref20.children,
      className = _ref20.className,
      buttonClassName = _ref20.buttonClassName,
      iconClassName = _ref20.iconClassName,
      contentClassName = _ref20.contentClassName,
      contentWrapperClassName = _ref20.contentWrapperClassName,
      _ref20$variant = _ref20.variant,
      variant = _ref20$variant === void 0 ? "default" : _ref20$variant,
      _ref20$showIcon = _ref20.showIcon,
      showIcon = _ref20$showIcon === void 0 ? true : _ref20$showIcon,
      _ref20$closeOnClickOu = _ref20.closeOnClickOutside,
      closeOnClickOutside = _ref20$closeOnClickOu === void 0 ? false : _ref20$closeOnClickOu,
      _ref20$expandOnDeskto = _ref20.expandOnDesktop,
      expandOnDesktop = _ref20$expandOnDeskto === void 0 ? "absolute" : _ref20$expandOnDeskto,
      _ref20$expandOnMobile = _ref20.expandOnMobile,
      expandOnMobile = _ref20$expandOnMobile === void 0 ? "inline" : _ref20$expandOnMobile,
      _ref20$expandOnTablet = _ref20.expandOnTablet,
      expandOnTablet = _ref20$expandOnTablet === void 0 ? "inline" : _ref20$expandOnTablet;
  var containerRef = useRef(null);

  var _useState3 = useState(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var handleClickOutside = function handleClickOutside(e) {
    if (closeOnClickOutside && containerRef.current && !containerRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  }; // close on click outside


  useEffect(function () {
    document.addEventListener("click", handleClickOutside);
    return function () {
      return document.removeEventListener("click", handleClickOutside);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: clsx(styles$b.dropDown, className, (_clsx15 = {}, _clsx15[styles$b.dropDownDefault] = variant == "default", _clsx15[styles$b.dropDownTransparent] = variant == "transparent", _clsx15[styles$b.mobileExpandInline] = expandOnMobile == "inline", _clsx15[styles$b.mobileExpandAbsolute] = expandOnMobile == "absolute", _clsx15[styles$b.mobileExpandOpen] = expandOnMobile == "open", _clsx15[styles$b.tabletExpandInline] = expandOnTablet == "inline", _clsx15[styles$b.tabletExpandAbsolute] = expandOnTablet == "absolute", _clsx15[styles$b.tabletExpandOpen] = expandOnTablet == "open", _clsx15[styles$b.desktopExpandInline] = expandOnDesktop == "inline", _clsx15[styles$b.desktopExpandAbsolute] = expandOnDesktop == "absolute", _clsx15[styles$b.desktopExpandOpen] = expandOnDesktop == "open", _clsx15[styles$b.dropDownOpen] = isOpen, _clsx15))
  }, /*#__PURE__*/React.createElement("button", {
    className: clsx(styles$b.button, buttonClassName),
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-label": label == null ? void 0 : label.toString()
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$b.label
  }, label), showIcon && /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-down",
    size: "1.5x",
    padding: false,
    className: clsx(iconClassName, styles$b.icon),
    ariaHidden: true
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$b.contentWrapper, contentWrapperClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$b.content, contentClassName)
  }, children)));
};

var styles$a = {
  "overlay": "Modal-module_overlay__RDGUr",
  "overlay-after-open": "Modal-module_overlay-after-open__2UlZC",
  "overlayAfterOpen": "Modal-module_overlay-after-open__2UlZC",
  "overlay-before-close": "Modal-module_overlay-before-close__2-Kg3",
  "overlayBeforeClose": "Modal-module_overlay-before-close__2-Kg3",
  "content": "Modal-module_content__saci_",
  "content-big": "Modal-module_content-big__1WVwG",
  "contentBig": "Modal-module_content-big__1WVwG",
  "content-medium": "Modal-module_content-medium__4F1jy",
  "contentMedium": "Modal-module_content-medium__4F1jy",
  "content-small": "Modal-module_content-small__288xD",
  "contentSmall": "Modal-module_content-small__288xD",
  "header": "Modal-module_header__1vRTX",
  "title": "Modal-module_title__36npx",
  "body": "Modal-module_body__1ieKO",
  "body-boxed": "Modal-module_body-boxed__2ERgN",
  "bodyBoxed": "Modal-module_body-boxed__2ERgN",
  "body-wide": "Modal-module_body-wide__Hfr9V",
  "bodyWide": "Modal-module_body-wide__Hfr9V",
  "body-full": "Modal-module_body-full__1lOZ0",
  "bodyFull": "Modal-module_body-full__1lOZ0",
  "with-padding-bottom": "Modal-module_with-padding-bottom__35HoJ",
  "withPaddingBottom": "Modal-module_with-padding-bottom__35HoJ",
  "body-title": "Modal-module_body-title__2yIci",
  "bodyTitle": "Modal-module_body-title__2yIci",
  "modal-footer": "Modal-module_modal-footer__202dT",
  "modalFooter": "Modal-module_modal-footer__202dT"
};

var ModalBody = function ModalBody(_ref21) {
  var _clsx16;

  var className = _ref21.className,
      _ref21$variant = _ref21.variant,
      variant = _ref21$variant === void 0 ? "wide" : _ref21$variant,
      _ref21$paddingBottom = _ref21.paddingBottom,
      paddingBottom = _ref21$paddingBottom === void 0 ? false : _ref21$paddingBottom,
      children = _ref21.children;
  return /*#__PURE__*/React.createElement(RemoveScroll, {
    className: clsx(className, (_clsx16 = {}, _clsx16[styles$a.body] = true, _clsx16[styles$a.bodyWide] = variant == "wide", _clsx16[styles$a.bodyBoxed] = variant == "boxed", _clsx16[styles$a.bodyFull] = variant == "full", _clsx16[styles$a.withPaddingBottom] = paddingBottom, _clsx16))
  }, children);
};

var ModalBodyTitle = function ModalBodyTitle(_ref22) {
  var children = _ref22.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$a.bodyTitle
  }, children);
};

var ModalFooter = function ModalFooter(_ref23) {
  var children = _ref23.children;
  return /*#__PURE__*/React.createElement("footer", {
    className: styles$a.modalFooter
  }, children);
};

var Modal = function Modal(_ref24) {
  var _clsx17;

  var children = _ref24.children,
      modal = _ref24.modal,
      title = _ref24.title,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? "big" : _ref24$size,
      _ref24$labels = _ref24.labels,
      labels = _ref24$labels === void 0 ? {
    close: "Close"
  } : _ref24$labels,
      props = _objectWithoutPropertiesLoose(_ref24, ["children", "modal", "title", "size", "labels"]);

  return /*#__PURE__*/React.createElement(BaseModal, Object.assign({}, modal, {
    data: {
      "content-name": props["data-content-name"]
    },
    contentLabel: "modal",
    closeTimeoutMS: 300,
    overlayClassName: {
      base: styles$a.overlay,
      afterOpen: styles$a.overlayAfterOpen,
      beforeClose: styles$a.overlayBeforeClose
    },
    className: clsx(styles$a.content, (_clsx17 = {}, _clsx17[styles$a.contentBig] = size == "big", _clsx17[styles$a.contentMedium] = size == "medium", _clsx17[styles$a.contentSmall] = size == "small", _clsx17))
  }), /*#__PURE__*/React.createElement("header", {
    className: styles$a.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$a.title
  }, title), /*#__PURE__*/React.createElement(Button, {
    renderAs: "button",
    variant: "link",
    size: "normal",
    iconName: "close",
    onClick: modal.onRequestClose
  }, labels.close)), children);
};

var styles$9 = {
  "carousel": "Slider-module_carousel__1gDjE",
  "slide": "Slider-module_slide__3-6l4",
  "with-mask": "Slider-module_with-mask__1aPIO",
  "withMask": "Slider-module_with-mask__1aPIO",
  "mask": "Slider-module_mask__3vnm0",
  "scrollbar": "Slider-module_scrollbar__2yI6Q",
  "scrollbar-step": "Slider-module_scrollbar-step__igb_L",
  "scrollbarStep": "Slider-module_scrollbar-step__igb_L",
  "scrollbar-step-active": "Slider-module_scrollbar-step-active__3bNjV",
  "scrollbarStepActive": "Slider-module_scrollbar-step-active__3bNjV",
  "controls": "Slider-module_controls__28jCX",
  "controls-left": "Slider-module_controls-left__JwqA1",
  "controlsLeft": "Slider-module_controls-left__JwqA1",
  "buttons": "Slider-module_buttons__3ec9K",
  "variant-white": "Slider-module_variant-white__3TSrY",
  "variantWhite": "Slider-module_variant-white__3TSrY",
  "variant-gray": "Slider-module_variant-gray__2DdfN",
  "variantGray": "Slider-module_variant-gray__2DdfN"
};

var SliderSlide = function SliderSlide(_ref25) {
  var children = _ref25.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var swiperConfigNormal = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerGroup: 1,
  breakpoints: {
    //MD
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 24
    },
    //LG
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 24
    },
    //XL
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 48
    }
  }
};
var swiperConfigWide = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerGroup: 1,
  breakpoints: {
    //MD
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 24
    },
    //LG
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 24
    },
    //XL
    1280: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 48
    }
  }
};

var Slider = function Slider(_ref26) {
  var _clsx18;

  var children = _ref26.children,
      _ref26$variantColor = _ref26.variantColor,
      variantColor = _ref26$variantColor === void 0 ? "neutral05" : _ref26$variantColor,
      _ref26$variant = _ref26.variant,
      variant = _ref26$variant === void 0 ? "normal" : _ref26$variant,
      _ref26$withMask = _ref26.withMask,
      withMask = _ref26$withMask === void 0 ? true : _ref26$withMask,
      _ref26$labels = _ref26.labels,
      labels = _ref26$labels === void 0 ? {
    goToPage: "Go to page",
    previous: "Previous",
    next: "Next",
    counterSeparator: "of"
  } : _ref26$labels,
      onSlideChange = _ref26.onSlideChange,
      otherProps = _objectWithoutPropertiesLoose(_ref26, ["children", "variantColor", "variant", "withMask", "labels", "onSlideChange"]);

  var swiperProps = variant == "normal" ? swiperConfigNormal : swiperConfigWide;

  var _useState4 = useState(0),
      currentSlide = _useState4[0],
      setCurrentSlide = _useState4[1];

  var _useState5 = useState(1),
      slidesPerGroup = _useState5[0],
      setSlidesPerGroup = _useState5[1];

  var _useState6 = useState(),
      swiper = _useState6[0],
      setSwiper = _useState6[1];

  var prevSlide = useCallback(function () {
    if (swiper) swiper.slidePrev();
  }, [swiper]);
  var nextSlide = useCallback(function () {
    if (swiper) swiper.slideNext();
  }, [swiper]);
  var gotoSlide = useCallback(function (index) {
    if (swiper) swiper.slideTo(index * slidesPerGroup);
  }, [swiper, slidesPerGroup]);
  var internalOnSlideChange = useCallback(function (e) {
    var current = Math.ceil(e.realIndex / (e.params.slidesPerGroup || 1));
    setCurrentSlide(current);
    if (onSlideChange) onSlideChange(current);
  }, [onSlideChange]);
  var onBreakpoint = useCallback(function (swiper, _breakpointParams) {
    setSlidesPerGroup(swiper.params.slidesPerGroup || 1);
  }, []);
  var slidesCount = React.Children.count(children);
  var totalPages = Math.ceil(slidesCount / slidesPerGroup);
  var withControls = totalPages > 1;
  var slidesWithProps = React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.createElement(SwiperSlide, null, child);
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, totalPages > 0 && /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx(styles$9.carousel, (_clsx18 = {}, _clsx18[styles$9.carouselNormal] = variant == "normal", _clsx18[styles$9.carouselWide] = variant == "wide", _clsx18[styles$9.variantGray] = variantColor == "neutral05", _clsx18[styles$9.variantWhite] = variantColor == "white", _clsx18[styles$9.withMask] = withMask, _clsx18))
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: styles$9.mask
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.sliderContainer
  }, /*#__PURE__*/React.createElement(Swiper, Object.assign({}, swiperProps, {
    slideToClickedSlide: true,
    uniqueNavElements: false,
    loop: false,
    loopFillGroupWithBlank: true,
    centerInsufficientSlides: true,
    passiveListeners: true,
    onSlideChange: internalOnSlideChange,
    onSwiper: setSwiper,
    onBreakpoint: onBreakpoint
  }), slidesWithProps))), withControls && /*#__PURE__*/React.createElement("div", {
    className: styles$9.controls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.controlsLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.scrollbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9.scrollbarStepActive,
    style: {
      width: "calc(100% / " + totalPages + ")",
      transform: "translateX(calc(" + currentSlide + " * 100%))"
    }
  }), Array.from({
    length: totalPages
  }, function (_, index) {
    return /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return gotoSlide(index);
      },
      key: index,
      className: styles$9.scrollbarStep,
      "aria-label": labels.goToPage + " " + (index + 1)
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$9.totalPageser
  }, currentSlide + 1, " ", labels.counterSeparator, " ", totalPages)), /*#__PURE__*/React.createElement("div", {
    className: "swiper-pagination"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$9.buttons
  }, /*#__PURE__*/React.createElement(PaginationButton, {
    "data-content-piece": "slider_previous_button",
    arrow: "left",
    disabled: swiper == null ? void 0 : swiper.isBeginning,
    onClick: function onClick() {
      prevSlide();
    },
    "aria-label": labels.previous
  }), /*#__PURE__*/React.createElement(PaginationButton, {
    "data-content-piece": "slider_next_button",
    arrow: "right",
    disabled: swiper == null ? void 0 : swiper.isEnd,
    onClick: function onClick() {
      nextSlide();
    },
    "aria-label": labels.next
  })))));
};

var styles$8 = {
  "mosaic": "MosaicLayout-module_mosaic__2bOWa",
  "variant-column-2": "MosaicLayout-module_variant-column-2__2Mtll",
  "variantColumn2": "MosaicLayout-module_variant-column-2__2Mtll",
  "variant-column-3": "MosaicLayout-module_variant-column-3__MPXnJ",
  "variantColumn3": "MosaicLayout-module_variant-column-3__MPXnJ",
  "variant-column-2_3": "MosaicLayout-module_variant-column-2_3__KYzP5",
  "variantColumn23": "MosaicLayout-module_variant-column-2_3__KYzP5"
};

var MosaicLayout = function MosaicLayout(_ref27) {
  var _clsx19;

  var _ref27$variant = _ref27.variant,
      variant = _ref27$variant === void 0 ? "column3" : _ref27$variant,
      children = _ref27.children,
      otherProps = _objectWithoutPropertiesLoose(_ref27, ["variant", "children"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx(styles$8.mosaic, (_clsx19 = {}, _clsx19[styles$8.variantColumn3] = variant == "column3", _clsx19[styles$8.variantColumn2] = variant == "column2", _clsx19[styles$8.variantColumn23] = variant == "column2+3", _clsx19))
  }, otherProps), children);
};

var cardImageRatioForMosaicIndex = function cardImageRatioForMosaicIndex(variant, index) {
  if (variant == "column2") return "card-panorama";
  if (variant == "column3") return "card";
  if (variant == "column2+3") if (index < 2) return "card-panorama";
  return "card";
};

var styles$7 = {
  "picture-card": "PictureCard-module_picture-card__3bB0r",
  "pictureCard": "PictureCard-module_picture-card__3bB0r",
  "border-destination": "PictureCard-module_border-destination__1hsT7",
  "borderDestination": "PictureCard-module_border-destination__1hsT7",
  "title": "PictureCard-module_title__4-D5J"
};
var styles$6 = {
  "image": "ImageRatio-module_image__1LJ1b",
  "image-inner": "ImageRatio-module_image-inner__1O6Dv",
  "imageInner": "ImageRatio-module_image-inner__1O6Dv",
  "aspect-ratio-card": "ImageRatio-module_aspect-ratio-card__3-CaA",
  "aspectRatioCard": "ImageRatio-module_aspect-ratio-card__3-CaA",
  "aspect-ratio-card-panorama": "ImageRatio-module_aspect-ratio-card-panorama__1VmY9",
  "aspectRatioCardPanorama": "ImageRatio-module_aspect-ratio-card-panorama__1VmY9",
  "aspect-ratio-card-compact": "ImageRatio-module_aspect-ratio-card-compact__1dxX5",
  "aspectRatioCardCompact": "ImageRatio-module_aspect-ratio-card-compact__1dxX5",
  "aspect-ratio-auto": "ImageRatio-module_aspect-ratio-auto__2JfHS",
  "aspectRatioAuto": "ImageRatio-module_aspect-ratio-auto__2JfHS"
};
var ImageRatio = /*#__PURE__*/React.memo(function (_ref28) {
  var _clsx20;

  var className = _ref28.className,
      ratio = _ref28.ratio,
      children = _ref28.children,
      props = _objectWithoutPropertiesLoose(_ref28, ["className", "ratio", "children"]);

  var aspectRatioStyle = ratio == "auto" ? computeAspectRatioStyle(props["width"], props["height"]) : undefined;
  var ratioClassName = clsx(styles$6.imageInner, className, (_clsx20 = {}, _clsx20[styles$6.aspectRatioAuto] = ratio == "auto", _clsx20[styles$6.aspectRatioCard] = ratio == "card", _clsx20[styles$6.aspectRatioCardPanorama] = ratio == "card-panorama", _clsx20[styles$6.aspectRatioCardCompact] = ratio == "card-compact", _clsx20));
  var newChildren = React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        className: ratioClassName,
        style: aspectRatioStyle
      });
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, newChildren);
});

var computeAspectRatioStyle = function computeAspectRatioStyle(width, height) {
  var defaultAspectRatioPadding = computeDefaultAspectRatio(width, height);
  return {
    "--default-aspect-ratio": defaultAspectRatioPadding
  };
};

var computeDefaultAspectRatio = function computeDefaultAspectRatio(width, height) {
  var padding = height / width * 100 + "%";
  return padding;
};

var PictureCard = function PictureCard(_ref29) {
  var _clsx21;

  var _ref29$borderColor = _ref29.borderColor,
      borderColor = _ref29$borderColor === void 0 ? "transparent" : _ref29$borderColor,
      trackingName = _ref29.trackingName,
      children = _ref29.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$7.pictureCard, (_clsx21 = {}, _clsx21[styles$7.borderDestination] = borderColor == "destination", _clsx21)),
    "data-content-name": trackingName
  }, children);
};

var PictureCardImage = function PictureCardImage(_ref30) {
  var children = _ref30.children;
  return /*#__PURE__*/React.createElement(ImageRatio, {
    ratio: "card"
  }, children);
};

var PictureCardTitle = function PictureCardTitle(_ref31) {
  var children = _ref31.children;
  return /*#__PURE__*/React.createElement("h3", {
    className: styles$7.title
  }, children);
};

var styles$5 = {
  "base-card": "BaseCard-module_base-card__OH5K1",
  "baseCard": "BaseCard-module_base-card__OH5K1",
  "text-align-left": "BaseCard-module_text-align-left__No80e",
  "textAlignLeft": "BaseCard-module_text-align-left__No80e",
  "text-align-center": "BaseCard-module_text-align-center__3yRwP",
  "textAlignCenter": "BaseCard-module_text-align-center__3yRwP",
  "background-neutral05": "BaseCard-module_background-neutral05__3ZoYw",
  "backgroundNeutral05": "BaseCard-module_background-neutral05__3ZoYw",
  "background-white": "BaseCard-module_background-white__13mSJ",
  "backgroundWhite": "BaseCard-module_background-white__13mSJ",
  "title": "BaseCard-module_title__2YP_S",
  "body": "BaseCard-module_body__YeWcf",
  "footer": "BaseCard-module_footer__3XaQR",
  "image": "BaseCard-module_image__3EOnD"
};
var styles$4 = {
  "responsive-image-container": "ResponsiveSanityImage-module_responsive-image-container__1hVxc",
  "responsiveImageContainer": "ResponsiveSanityImage-module_responsive-image-container__1hVxc"
};
var SanityClientConfigContext = /*#__PURE__*/React.createContext(undefined);

var useSanityClient = function useSanityClient(extraOptions) {
  var sanityClientConfig = useContext(SanityClientConfigContext);
  if (!sanityClientConfig) return undefined;

  var options = _extends({}, sanityClientConfig, extraOptions);

  return sanityClient(options);
};

var SANITY_REF_PATTERN = /^image-([a-f\d]+)-(\d+x\d+)-(\w+)$/;

var isSanityImagePresent = function isSanityImagePresent(image) {
  return !!(image != null && image.asset) && (isPresent(image.asset._id) || isPresent(image.asset["_ref"]));
};

var parseSanityImageRef = function parseSanityImageRef(id) {
  try {
    var _ref32 = SANITY_REF_PATTERN.exec(id) || [],
        assetId = _ref32[1],
        dimensions = _ref32[2],
        format = _ref32[3];

    var _dimensions$split$map = dimensions.split("x").map(function (v) {
      return parseInt(v, 10);
    }),
        width = _dimensions$split$map[0],
        height = _dimensions$split$map[1];

    return {
      assetId: assetId,
      dimensions: {
        width: width,
        height: height
      },
      format: format
    };
  } catch (_unused2) {
    throw new Error("Could not parse image ID \"" + id + "\"");
  }
};

var toSanityAsset = function toSanityAsset(image) {
  var asset = image.asset,
      hotspot = image.hotspot,
      crop = image.crop;
  if (!asset) return undefined;

  var sanityAsset = _extends({}, asset, {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    _id: asset._id || asset["_ref"],
    hotspot: hotspot,
    crop: crop
  });

  return sanityAsset;
};

var getLocalizedAlt = function getLocalizedAlt(localizedAlt) {
  if (!localizedAlt) return;
  if (typeof localizedAlt !== "string" && "localized" in localizedAlt) return localizedAlt.localized;
  return localizedAlt;
};

var buildSrc = function buildSrc(builder, asset, // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
_ref33) {
  var width = _ref33.width,
      height = _ref33.height,
      config = _objectWithoutPropertiesLoose(_ref33, ["width", "height"]);

  var _parseSanityImageRef = parseSanityImageRef(asset._id),
      dimensions = _parseSanityImageRef.dimensions;

  var origRatio = dimensions.width / dimensions.height;
  width = width || dimensions.width;
  height = height || Math.round(width / origRatio);
  return imageUrl(builder, asset, _extends({}, config, {
    width: width,
    height: height
  }));
};

var buildSrcSet = function buildSrcSet(builder, asset, config) {
  var _parseSanityImageRef2 = parseSanityImageRef(asset._id),
      dimensions = _parseSanityImageRef2.dimensions;

  var fitMode = config.fit || DEFAULT_IMAGE_CONFIG.fit; // Determine dimensions and ratios for srcSet calculations

  var origRatio = dimensions.width / dimensions.height;
  var width = config.width || dimensions.width;
  var height = config.height || Math.round(width / origRatio);
  var targetRatio = width / height;
  var cropRatio = origRatio;
  var maxWidth = dimensions.width;
  var maxHeight = dimensions.height; // Compensate for dimensional changes if image was cropped in Sanity

  if (fitMode != "clip" && "crop" in asset && asset.crop && Object.values(asset.crop).some(function (n) {
    return n && n > 0;
  })) {
    var cropWidth = dimensions.width - (asset.crop.left || 0) * dimensions.width - (asset.crop.right || 0) * dimensions.width;
    var cropHeight = dimensions.height - (asset.crop.top || 0) * dimensions.height - (asset.crop.bottom || 0) * dimensions.height;
    cropRatio = cropWidth / cropHeight;

    if (cropRatio > origRatio) {
      maxHeight = cropHeight;
    } else {
      maxWidth = cropWidth;
    }
  }

  return Object.values([0.5, 0.75, 1, 1.5, 2].reduce(function (set, dpr) {
    var url = imageUrl(builder, asset, _extends({}, config, {
      dpr: dpr
    }));
    var size = Math.round( // For modes where Sanity will not scale up, determine
    // the anticipated final width based on the params
    ["fillmax", "max", "min"].includes(fitMode) ? targetRatio < origRatio ? Math.min(maxHeight / (height * dpr) * (width * dpr), width * dpr) : Math.min(width * dpr, maxWidth) : width * dpr); // Avoid duplicate sizes in srcSet list

    if (!set[size]) {
      set[size] = url + " " + size + "w";
    }

    return set;
  }, {})).join(", ");
};

var imageUrl = function imageUrl(builder, asset, // eslint-disable-next-line @typescript-eslint/no-explicit-any
params) {
  if (params === void 0) {
    params = {};
  } //fix for sanity:


  var _params = params,
      fit = _params.fit,
      width = _params.width,
      height = _params.height,
      otherParams = _objectWithoutPropertiesLoose(_params, ["fit", "width", "height"]);

  var sanityParams = {
    fit: fit,
    width: width,
    height: undefined
  };
  if (fit != "clip") sanityParams = _extends({}, sanityParams, {
    height: height
  }); //TODO: https://github.com/sanity-io/image-url/issues/32
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  return Object.entries(_extends({}, DEFAULT_IMAGE_CONFIG, sanityParams, otherParams)).reduce(function (acc, _ref34) {
    var key = _ref34[0],
        value = _ref34[1];
    return value ? Array.isArray(value) ? acc[key].apply(acc, value) : acc[key](value) : acc;
  }, builder.image(asset)).url();
};
/* eslint-disable jsx-a11y/alt-text */


var DEFAULT_IMAGE_CONFIG = {
  auto: "format",
  fit: "max",
  quality: 75
};

var SanityImage$1 = function SanityImage$1(imageProps) {
  var _sanityAsset$metadata;

  var hotspot = imageProps.hotspot,
      _imageProps$crop = imageProps.crop,
      crop = _imageProps$crop === void 0 ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _imageProps$crop,
      _imageProps$options = imageProps.options,
      options = _imageProps$options === void 0 ? {
    __experimentalAspectRatio: false
  } : _imageProps$options,
      _imageProps$config = imageProps.config,
      config = _imageProps$config === void 0 ? {} : _imageProps$config,
      props = _objectWithoutPropertiesLoose(imageProps, ["hotspot", "crop", "options", "config"]);

  var sanityClient = useSanityClient({
    useCdn: true
  });
  var builder = sanityImageUrl(sanityClient);
  var width = imageProps.width,
      height = imageProps.height;
  var style = useMemo(function () {
    if (!hotspot) return undefined;
    return {
      objectPosition: [hotspot.x, hotspot.y] // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .map(function (value) {
        return (value * 100).toFixed(2) + "%";
      }).join(" ")
    };
  }, [hotspot]);
  var sanityAsset = toSanityAsset(imageProps);
  if (!isPresent(sanityAsset)) return null;
  var preview = (_sanityAsset$metadata = sanityAsset.metadata) == null ? void 0 : _sanityAsset$metadata.preview;
  var alt = getLocalizedAlt(imageProps["alt"]); // Fallback to asset.<alt> if no `alt` prop provided, if configured
  //   if (__GATSBY_PLUGIN_SANITY_IMAGE__ALT_FIELD__) {
  //     props.alt = props.alt ?? asset[__GATSBY_PLUGIN_SANITY_IMAGE__ALT_FIELD__]
  //   }
  // Create default src and build srcSet

  var src = buildSrc(builder, sanityAsset, _extends({}, config, {
    width: width,
    height: height
  }));
  var srcSet = buildSrcSet(builder, sanityAsset, _extends({}, config, {
    width: width,
    height: height
  }));

  if (options.__experimentalAspectRatio && isPresent(crop)) {
    var _width; // If enabled, this will estimate the final aspect ratio based on
    // the dimensions of the original image and the crop parameter,
    // then use this aspect ratio to apply `width` and `height` attrs
    // to both the preview and final images.
    //
    // Note: No attempts are made to compensate for the `fit` mode or
    // image params that transform the final output dimensions in this
    // early proof-of-concept version.


    var _parseSanityImageRef3 = parseSanityImageRef(sanityAsset._id),
        dimensions = _parseSanityImageRef3.dimensions; // If `crop` isn't set, use fallback values.


    var _ref35 = crop || {},
        _ref35$left = _ref35.left,
        left = _ref35$left === void 0 ? 0 : _ref35$left,
        _ref35$right = _ref35.right,
        right = _ref35$right === void 0 ? 0 : _ref35$right,
        _ref35$top = _ref35.top,
        top = _ref35$top === void 0 ? 0 : _ref35$top,
        _ref35$bottom = _ref35.bottom,
        bottom = _ref35$bottom === void 0 ? 0 : _ref35$bottom;

    var croppedWidth = dimensions.width * (1 - left - right);
    var croppedHeight = dimensions.height * (1 - top - bottom);
    var ratio = croppedWidth / croppedHeight;
    width = width ? parseInt((_width = width) == null ? void 0 : _width.toString(), 10) : dimensions.width;
    height = height || Math.round(width / ratio);
  }

  var Image = preview ? ImageWithPreview : "img"; // Short circuit for SVG images

  if (parseSanityImageRef(sanityAsset._id).format === "svg") {
    return /*#__PURE__*/React.createElement("img", Object.assign({
      src: imageUrl(builder, sanityAsset)
    }, props, {
      alt: alt
    }));
  }

  return /*#__PURE__*/React.createElement(Image, Object.assign({
    preview: preview,
    src: src,
    srcSet: srcSet,
    style: style,
    loading: "lazy",
    width: width,
    height: height
  }, props, {
    alt: alt
  }));
};

var ImageWithPreview = function ImageWithPreview(_ref36) {
  var preview = _ref36.preview,
      props = _objectWithoutPropertiesLoose(_ref36, ["preview"]);

  var _useState7 = useState(false),
      loaded = _useState7[0],
      setLoaded = _useState7[1];

  var ref = useRef(null);
  var onLoad = useCallback(function () {
    setLoaded(true);
  }, []);
  useEffect(function () {
    if (ref.current && ref.current.complete) {
      onLoad();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !loaded && /*#__PURE__*/React.createElement("img", {
    src: preview,
    alt: props.alt,
    id: props.id,
    className: props.className,
    style: props.style,
    width: props.width,
    height: props.height,
    "data-lqip": true
  }), /*#__PURE__*/React.createElement("img", Object.assign({
    ref: ref,
    onLoad: onLoad,
    "data-loading": loaded ? null : true
  }, props)));
};

var styles$3 = {
  "container": "SanityImage-module_container__3iGen",
  "image-fit-crop": "SanityImage-module_image-fit-crop__2jcSB",
  "imageFitCrop": "SanityImage-module_image-fit-crop__2jcSB",
  "image-fit-original": "SanityImage-module_image-fit-original__35QWl",
  "imageFitOriginal": "SanityImage-module_image-fit-original__35QWl"
};

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

var UncontrolledSanityImage = function UncontrolledSanityImage(_ref37, ref) {
  var _classnames;

  var _ref37$image = _ref37.image,
      image = _ref37$image === void 0 ? {} : _ref37$image,
      className = _ref37.className,
      _ref37$visible = _ref37.visible,
      visible = _ref37$visible === void 0 ? true : _ref37$visible,
      _ref37$fit = _ref37.fit,
      fit = _ref37$fit === void 0 ? "crop" : _ref37$fit,
      style = _ref37.style,
      imgTagProps = _objectWithoutPropertiesLoose(_ref37, ["image", "className", "visible", "fit", "style"]);

  var ratioClass = classnames((_classnames = {}, _classnames[styles$3.imageFitCrop] = fit == "crop", _classnames[styles$3.imageFitOriginal] = fit == "original", _classnames));
  if (!isSanityImagePresent(image)) return null;
  var alt = getLocalizedAlt(image["alt"]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classnames([styles$3.container, ratioClass, className]),
    style: style
  }, visible && /*#__PURE__*/React.createElement(SanityImage$1, Object.assign({}, image, imgTagProps, {
    alt: alt,
    config: {
      fit: fit == "crop" ? "max" : "clip"
    }
  })));
};

var SanityImage = /*#__PURE__*/React.forwardRef(UncontrolledSanityImage); // Originally inspired by  David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// `wait` milliseconds.

var debounce = function debounce(func, wait) {
  var timeout; // This is the function that is returned and will be executed many times
  // We spread (...args) to capture any number of parameters we want to pass

  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    } // The callback function to be executed after
    // the debounce time has elapsed


    var later = function later() {
      // null timeout to indicate the debounce ended
      timeout = null; // Execute the callback

      func.apply(void 0, args);
    }; // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout


    if (timeout) clearTimeout(timeout); // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)

    timeout = setTimeout(later, wait);
  };
};

var useDebouncedResizeObserver = function useDebouncedResizeObserver(wait) {
  var _useState8 = useState({}),
      size = _useState8[0],
      setSize = _useState8[1];

  var ref = useRef(null);
  React.useEffect(function () {
    var handleResize = function handleResize() {
      var _ref$current;

      var rect = (_ref$current = ref.current) == null ? void 0 : _ref$current.getBoundingClientRect();

      if (rect) {
        setSize({
          width: Math.round(rect.width),
          height: Math.round(rect.height)
        });
      }
    };

    var debHandleResize = debounce(handleResize, wait);
    handleResize();
    window.addEventListener("resize", debHandleResize); // clean up function

    return function () {
      // remove resize listener
      window.removeEventListener("resize", debHandleResize);
    };
  }, [wait]);
  return _extends({
    ref: ref
  }, size);
};

var ResponsiveSanityImage = function ResponsiveSanityImage(_ref38) {
  var className = _ref38.className,
      defaultWidth = _ref38.defaultWidth,
      defaultHeight = _ref38.defaultHeight,
      props = _objectWithoutPropertiesLoose(_ref38, ["className", "defaultWidth", "defaultHeight"]);

  var _useDebouncedResizeOb = useDebouncedResizeObserver(500),
      ref = _useDebouncedResizeOb.ref,
      width = _useDebouncedResizeOb.width,
      height = _useDebouncedResizeOb.height;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SanityImage, Object.assign({
    ref: ref
  }, props, {
    className: clsx([styles$4.responsiveImageContainer, className]),
    width: width,
    height: height
  })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement(SanityImage, Object.assign({}, props, {
    width: defaultWidth,
    height: defaultHeight
  }))));
};

var BaseCardImage = function BaseCardImage(_ref39) {
  var children = _ref39.children,
      ratio = _ref39.ratio;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5.image
  }, /*#__PURE__*/React.createElement(ImageRatio, {
    ratio: ratio
  }, children));
};

var BaseCardSanityImage = function BaseCardSanityImage(_ref40) {
  var ratio = _ref40.ratio,
      props = _objectWithoutPropertiesLoose(_ref40, ["ratio"]);

  return /*#__PURE__*/React.createElement(BaseCardImage, {
    ratio: ratio
  }, isSanityImagePresent(props.image) && /*#__PURE__*/React.createElement(ResponsiveSanityImage, Object.assign({}, props, {
    defaultWidth: 400,
    defaultHeight: 600,
    draggable: false,
    loading: "lazy"
  })));
};

var BaseCardTitle = function BaseCardTitle(_ref41) {
  var _ref41$className = _ref41.className,
      className = _ref41$className === void 0 ? "" : _ref41$className,
      children = _ref41.children;
  return /*#__PURE__*/React.createElement("h3", {
    className: styles$5.title + " " + className
  }, children);
};

var BaseCardBody = function BaseCardBody(_ref42) {
  var _ref42$className = _ref42.className,
      className = _ref42$className === void 0 ? "" : _ref42$className,
      children = _ref42.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5.body + " " + className
  }, children);
};

var BaseCardFooter = function BaseCardFooter(_ref43) {
  var _ref43$className = _ref43.className,
      className = _ref43$className === void 0 ? "" : _ref43$className,
      children = _ref43.children;
  return /*#__PURE__*/React.createElement("footer", {
    className: styles$5.footer + " " + className
  }, children);
};

var BaseCard = function BaseCard(_ref44) {
  var _clsx22;

  var _ref44$background = _ref44.background,
      background = _ref44$background === void 0 ? "transparent" : _ref44$background,
      _ref44$textAlign = _ref44.textAlign,
      textAlign = _ref44$textAlign === void 0 ? "left" : _ref44$textAlign,
      className = _ref44.className,
      children = _ref44.children;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles$5.baseCard, className, (_clsx22 = {}, _clsx22[styles$5.backgroundNeutral05] = background == "neutral05", _clsx22[styles$5.backgroundWhite] = background == "white", _clsx22[styles$5.textAlignLeft] = textAlign == "left", _clsx22[styles$5.textAlignCenter] = textAlign == "center", _clsx22))
  }, children);
};

var styles$2 = {
  "opening-text": "OpeningText-module_opening-text__3sfv3",
  "openingText": "OpeningText-module_opening-text__3sfv3",
  "heading": "OpeningText-module_heading__1gW9U",
  "sub-heading": "OpeningText-module_sub-heading__19kL6",
  "subHeading": "OpeningText-module_sub-heading__19kL6",
  "body": "OpeningText-module_body__3A-ll"
};

var OpeningTextBody = function OpeningTextBody(_ref45) {
  var children = _ref45.children;
  return /*#__PURE__*/React.createElement(SectionTitleBody, {
    className: styles$2.body
  }, children);
};

var OpeningTextHeading = function OpeningTextHeading(_ref46) {
  var children = _ref46.children;
  return /*#__PURE__*/React.createElement(SectionTitleHeading, {
    className: styles$2.heading,
    priority: 1
  }, children);
};

var OpeningTextSubHeading = function OpeningTextSubHeading(_ref47) {
  var children = _ref47.children;
  return /*#__PURE__*/React.createElement("h3", {
    className: styles$2.subHeading
  }, children);
};

var OpeningText = function OpeningText(_ref48) {
  var children = _ref48.children,
      _ref48$className = _ref48.className,
      className = _ref48$className === void 0 ? undefined : _ref48$className;
  return /*#__PURE__*/React.createElement(SectionTitle, {
    variant: "wide",
    className: clsx(styles$2.openingText, className),
    "data-content-name": "opening_text"
  }, children);
};

var styles$1 = {
  "list": "Pagination-module_list__h5icl",
  "item": "Pagination-module_item__2Leb2",
  "active": "Pagination-module_active__12Nsb"
}; // FROM: https://www.digitalocean.com/community/tutorials/how-to-build-custom-pagination-with-react

var LEFT_PAGE = "LEFT";
var RIGHT_PAGE = "RIGHT";
/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */

var range = function range(from, to, step) {
  if (step === void 0) {
    step = 1;
  }

  var i = from;
  var range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};
/**
 * Let's say we have 10 pages and we set pageNeighbours to 2
 * Given that the current page is 6
 * The pagination control will look like the following:
 *
 * (1) < {4 5} [6] {7 8} > (10)
 *
 * (x) => terminal pages: first and last page(always visible)
 * [x] => represents current page
 * {...x} => represents page neighbours
 */


var getPageNumbers = function getPageNumbers(totalPages, currentPage, pageNeighbours) {
  // const totalPages = this.totalPages;
  // const currentPage = this.state.currentPage;
  // const pageNeighbours = this.pageNeighbours;

  /**
   * totalNumbers: the total page numbers to show on the control
   * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
   */
  var totalNumbers = pageNeighbours * 2 + 3;
  var totalBlocks = totalNumbers + 2;

  if (totalPages > totalBlocks) {
    var startPage = Math.max(2, currentPage - pageNeighbours);
    var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    var pages = range(startPage, endPage);
    /**
     * hasLeftSpill: has hidden pages to the left
     * hasRightSpill: has hidden pages to the right
     * spillOffset: number of hidden pages either to the left or to the right
     */

    var hasLeftSpill = startPage > 2;
    var hasRightSpill = totalPages - endPage > 1;
    var spillOffset = totalNumbers - (pages.length + 1);

    switch (true) {
      // handle: (1) < {5 6} [7] {8 9} (10)
      case hasLeftSpill && !hasRightSpill:
        {
          var extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE].concat(extraPages, pages);
          break;
        }
      // handle: (1) {2 3} [4] {5 6} > (10)

      case !hasLeftSpill && hasRightSpill:
        {
          var _extraPages = range(endPage + 1, endPage + spillOffset);

          pages = [].concat(pages, _extraPages, [RIGHT_PAGE]);
          break;
        }
      // handle: (1) < {4 5} [6] {7 8} > (10)

      case hasLeftSpill && hasRightSpill:
      default:
        {
          pages = [LEFT_PAGE].concat(pages, [RIGHT_PAGE]);
          break;
        }
    }

    return [1].concat(pages, [totalPages]);
  }

  return range(1, totalPages);
};

var Pagination = function Pagination(_ref49) {
  var currentPage = _ref49.currentPage,
      urlBuilder = _ref49.urlBuilder,
      totalPages = _ref49.totalPages;
  var pageNumbersToLink = getPageNumbers(totalPages, currentPage, 1);
  return /*#__PURE__*/React.createElement("ul", {
    className: styles$1.list
  }, pageNumbersToLink.map(function (page) {
    var _clsx23;

    if (page === LEFT_PAGE) return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: styles$1.item
    }, /*#__PURE__*/React.createElement(Button, {
      renderAs: "a",
      variant: "link",
      href: urlBuilder(currentPage - 1),
      iconName: "chevron-left"
    }));
    if (page === RIGHT_PAGE) return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: styles$1.item
    }, /*#__PURE__*/React.createElement(Button, {
      renderAs: "a",
      variant: "link",
      href: urlBuilder(currentPage + 1),
      iconName: "chevron-right"
    }));
    return /*#__PURE__*/React.createElement("li", {
      key: page,
      className: clsx(styles$1.item, (_clsx23 = {}, _clsx23[styles$1.active] = currentPage == page, _clsx23))
    }, /*#__PURE__*/React.createElement(Button, {
      renderAs: "a",
      variant: "link",
      href: urlBuilder(page)
    }, page));
  }));
};

var SanityImageRatio = function SanityImageRatio(_ref50) {
  var children = _ref50.children,
      image = _ref50.image,
      ratio = _ref50.ratio,
      props = _objectWithoutPropertiesLoose(_ref50, ["children", "image", "ratio"]);

  if (ratio == "auto") {
    var _image$asset;

    if (!(image != null && (_image$asset = image.asset) != null && _image$asset._id) || !isSanityImagePresent(image)) return null;

    var _parseSanityImageRef4 = parseSanityImageRef(image.asset._id),
        dimensions = _parseSanityImageRef4.dimensions;

    return /*#__PURE__*/React.createElement(ImageRatio, Object.assign({
      ratio: "auto"
    }, props, dimensions), children);
  } else return /*#__PURE__*/React.createElement(ImageRatio, Object.assign({
    ratio: ratio
  }, props), children);
};

var styles = {
  "hero-banner": "HeroBanner-module_hero-banner__CHav3",
  "heroBanner": "HeroBanner-module_hero-banner__CHav3",
  "hero-image": "HeroBanner-module_hero-image__3rV2R",
  "heroImage": "HeroBanner-module_hero-image__3rV2R",
  "size-compact": "HeroBanner-module_size-compact__FCW_9",
  "sizeCompact": "HeroBanner-module_size-compact__FCW_9",
  "background-image-container": "HeroBanner-module_background-image-container__3UYyA",
  "backgroundImageContainer": "HeroBanner-module_background-image-container__3UYyA",
  "overlay": "HeroBanner-module_overlay__2dkhO",
  "left-panel": "HeroBanner-module_left-panel__7bSWM",
  "leftPanel": "HeroBanner-module_left-panel__7bSWM",
  "right-panel": "HeroBanner-module_right-panel__30kd1",
  "rightPanel": "HeroBanner-module_right-panel__30kd1",
  "title": "HeroBanner-module_title__3ugwT",
  "content": "HeroBanner-module_content__3iMi5",
  "action-container": "HeroBanner-module_action-container__3aY-g",
  "actionContainer": "HeroBanner-module_action-container__3aY-g"
};

var HeroBannerLeftPanel = function HeroBannerLeftPanel(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.leftPanel
  }, props.children);
};

var HeroBannerRightPanel = function HeroBannerRightPanel(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.rightPanel
  }, props.children);
};

var HeroBannerTitle = function HeroBannerTitle(props) {
  return /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, props.children);
};

var HeroBannerContent = function HeroBannerContent(props) {
  return /*#__PURE__*/React.createElement("h2", {
    className: styles.content
  }, props.children);
};

var HeroBannerAction = function HeroBannerAction(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.actionContainer
  }, props.children);
};

var HeroBanner = function HeroBanner(props) {
  var _clsx24;

  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.heroBanner, (_clsx24 = {}, _clsx24[styles.sizeCompact] = props.size == "compact", _clsx24)),
    "data-content-name": "hero"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.backgroundImageContainer
  }, props.background && /*#__PURE__*/React.createElement(ResponsiveSanityImage, {
    image: props.background,
    className: styles.heroImage,
    defaultWidth: 1024,
    defaultHeight: 400
  })), /*#__PURE__*/React.createElement(SectionContainer, {
    className: styles.overlay
  }, props.children));
};

export { BaseCard, BaseCardBody, BaseCardFooter, BaseCardImage, BaseCardSanityImage, BaseCardTitle, Button, ButtonsContainer, DescriptionText, DescriptionTextColumn, DescriptionTextColumnContent, DescriptionTextColumnContentLeft, DescriptionTextColumnContentRight, DescriptionTextColumnLeadIn, DescriptionTextColumnTitle, DescriptionTextContent, DescriptionTextLeadIn, DestinationColor, DropDown, FloatLabel, HeroBanner, HeroBannerAction, HeroBannerContent, HeroBannerLeftPanel, HeroBannerRightPanel, HeroBannerTitle, Icon, ImageRatio, InlineFormContainer, InputCheckbox, InputForm, InputText, InputWithError, Logo, Modal, ModalBody, ModalBodyTitle, ModalFooter, MosaicLayout, OpeningText, OpeningTextBody, OpeningTextHeading, OpeningTextSubHeading, Pagination, PaginationButton, PhoneInput, PictureCard, PictureCardImage, PictureCardTitle, ResponsiveSanityImage, SanityClientConfigContext, SanityImage, SanityImageRatio, SectionContainer, SectionDivider, SectionTitle, SectionTitleBody, SectionTitleHeading, Select, Slider, SliderSlide, TextArea, TextStyle, Theme, buildSrc as buildSanityImageSrc, cardImageRatioForMosaicIndex, computeAspectRatioStyle, destinationId2ColorMap, isSanityImagePresent, imageUrl as sanityImageUrl, useDebouncedResizeObserver, useSanityClient };